
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("fNJLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $183325db1cca8eeb$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $6Tw9l = parcelRequire("6Tw9l");

var $2FwjZ = parcelRequire("2FwjZ");

var $dHHKP = parcelRequire("dHHKP");

var $5KYHN = parcelRequire("5KYHN");
/**
 * Synchronous renderer node mapping for media nodes
 *
 * WARNING: This is an EXPERIMENTAL entry point and may change without notice in the future. Use it only at your own risk!
 *
 * Context: https://hello.atlassian.net/wiki/spaces/JIE/pages/5342146338 (Atlassian-internal)
 */ const $183325db1cca8eeb$var$nodeToReact = {
    media: (0, $6Tw9l.default),
    mediaGroup: (0, $2FwjZ.default),
    mediaInline: (0, $dHHKP.default),
    mediaSingle: (0, $5KYHN.default)
};
var $183325db1cca8eeb$export$2e2bcd8739ae039 = $183325db1cca8eeb$var$nodeToReact;

});
parcelRegister("6Tw9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb7f1ffdadcf9370$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $e2B2h = parcelRequire("e2B2h");

var $eUaD0 = parcelRequire("eUaD0");

var $4sxxB = parcelRequire("4sxxB");

var $jhKIq = parcelRequire("jhKIq");

var $jMtSb = parcelRequire("jMtSb");

var $jxPcD = parcelRequire("jxPcD");

var $9Ybet = parcelRequire("9Ybet");

var $g9wjI = parcelRequire("g9wjI");

var $bMFKb = parcelRequire("bMFKb");
var $9XXFf = parcelRequire("9XXFf");

var $eGOwo = parcelRequire("eGOwo");

var $7ueoK = parcelRequire("7ueoK");

var $fpMtm = parcelRequire("fpMtm");

var $11jfh = parcelRequire("11jfh");
var $a61Rj = parcelRequire("a61Rj");
var $avOy4 = parcelRequire("avOy4");
var $88noB = parcelRequire("88noB");

var $6YFG2 = parcelRequire("6YFG2");

var $8QIFO = parcelRequire("8QIFO");

var $eq5No = parcelRequire("eq5No");

var $4Fc33 = parcelRequire("4Fc33");

var $e2m7L = parcelRequire("e2m7L");
function $cb7f1ffdadcf9370$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cb7f1ffdadcf9370$var$linkStyle = {
    name: "14m5vmv",
    styles: "position:absolute;background:transparent;top:0;right:0;bottom:0;left:0;cursor:pointer;width:100% !important;height:100% !important"
};
const $cb7f1ffdadcf9370$var$borderStyle = {
    name: "10uwk9w",
    styles: "position:absolute;width:100% !important;height:100% !important"
};
const $cb7f1ffdadcf9370$var$MediaBorder = ({ mark: mark, children: children })=>{
    if (!mark) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, children);
    const borderColor = mark?.attrs.color ?? '';
    const borderWidth = mark?.attrs.size ?? 0;
    const paletteColorValue = (0, $9Ybet.hexToEditorBorderPaletteColor)(borderColor) || borderColor;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-mark-type": "border",
        "data-color": borderColor,
        "data-size": borderWidth,
        css: $cb7f1ffdadcf9370$var$borderStyle,
        style: {
            borderRadius: `${borderWidth}px`,
            boxShadow: `0 0 0 ${borderWidth}px ${paletteColorValue}`
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jhKIq.MediaBorderGapFiller), {
        borderColor: borderColor
    }), children);
};
const $cb7f1ffdadcf9370$var$MediaLink = ({ mark: mark, children: children, onClick: onClick })=>{
    if (!mark) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, children);
    const linkHref = mark?.attrs.href;
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $1NIU8.jsx)("a", {
        href: linkHref,
        rel: "noreferrer noopener",
        onClick: onClick,
        "data-block-link": linkHref,
        css: $cb7f1ffdadcf9370$var$linkStyle
    }, children));
};
const $cb7f1ffdadcf9370$var$MediaAnnotation = ({ mark: mark, children: children })=>{
    if (!mark) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, children);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $fpMtm.default), {
        id: mark.attrs.id,
        annotationType: mark.attrs.annotationType,
        dataAttributes: {
            'data-renderer-mark': true,
            'data-block-mark': true
        },
        // This should be fine being empty [] since the serializer serializeFragmentChild getMarkProps call always passes
        annotationParentIds: [],
        allowAnnotations: true,
        useBlockLevel: true
    }, children);
};
const $cb7f1ffdadcf9370$var$MediaAnnotations = ({ marks: marks = [], children: children })=>{
    // Early Exit
    if (marks.length === 0) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, children);
    // Recursive marks
    const currentMark = marks[0];
    const otherMarks = marks.slice(1);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$MediaAnnotation, {
        key: currentMark.attrs.id,
        mark: currentMark
    }, otherMarks.length ? /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$MediaAnnotations, {
        marks: otherMarks
    }, children) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, children)));
};
const $cb7f1ffdadcf9370$var$CommentBadge = (0, $6YFG2.default)((0, $11jfh.CommentBadge));
const $cb7f1ffdadcf9370$var$CommentBadgeWrapper = ({ marks: marks, mediaSingleElement: mediaSingleElement, isDrafting: isDrafting = false, ...rest })=>{
    const [status, setStatus] = (0, $eJOHy.useState)('default');
    const [entered, setEntered] = (0, $eJOHy.useState)(false);
    const updateSubscriber = (0, $eq5No.useInlineCommentSubscriberContext)();
    const activeParentIds = (0, $8QIFO.useInlineCommentsFilter)({
        annotationIds: marks?.map((mark)=>mark.attrs.id) ?? [
            ''
        ],
        filter: {
            state: (0, $jxPcD.AnnotationMarkStates).ACTIVE
        }
    });
    (0, $eJOHy.useEffect)(()=>{
        const observer = new MutationObserver((mutationList)=>{
            mutationList.forEach((mutation)=>{
                const parentNode = mutation.target.parentNode;
                if (mutation.attributeName === 'data-has-focus') {
                    const isMediaCaption = parentNode?.closest('[data-media-caption="true"]');
                    const elementHasFocus = parentNode?.querySelector('[data-has-focus="true"]') && !isMediaCaption;
                    elementHasFocus ? setStatus('active') : setStatus('default');
                }
            });
        });
        if (mediaSingleElement) observer.observe(mediaSingleElement, {
            attributes: true,
            subtree: true,
            attributeFilter: [
                'data-has-focus'
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement,
        setStatus
    ]);
    if (!isDrafting && !activeParentIds.length) return null;
    const onClick = (e)=>{
        e.preventDefault();
        if (updateSubscriber) updateSubscriber.emit((0, $4Fc33.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: activeParentIds,
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            eventTarget: e.target,
            // use mediaSingle here to align with annotation viewed event dispatched in editor
            eventTargetType: 'mediaSingle',
            viewMethod: (0, $9XXFf.VIEW_METHOD).BADGE
        });
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$CommentBadge, {
        onMouseEnter: ()=>setEntered(true),
        onMouseLeave: ()=>setEntered(false),
        status: entered ? 'entered' : status,
        onClick: onClick,
        ...rest
    });
};
const $cb7f1ffdadcf9370$var$CommentBadgeNextWrapper = ({ marks: marks, mediaSingleElement: mediaSingleElement, isDrafting: isDrafting = false, ...rest })=>{
    const [status, setStatus] = (0, $eJOHy.useState)('default');
    const [entered, setEntered] = (0, $eJOHy.useState)(false);
    const updateSubscriber = (0, $eq5No.useInlineCommentSubscriberContext)();
    const activeParentIds = (0, $8QIFO.useInlineCommentsFilter)({
        annotationIds: marks?.map((mark)=>mark.attrs.id) ?? [
            ''
        ],
        filter: {
            state: (0, $jxPcD.AnnotationMarkStates).ACTIVE
        }
    });
    (0, $eJOHy.useEffect)(()=>{
        const observer = new MutationObserver((mutationList)=>{
            mutationList.forEach((mutation)=>{
                const parentNode = mutation.target.parentNode;
                if (mutation.attributeName === 'data-has-focus') {
                    const isMediaCaption = parentNode?.closest('[data-media-caption="true"]');
                    const elementHasFocus = parentNode?.querySelector('[data-has-focus="true"]') && !isMediaCaption;
                    elementHasFocus ? setStatus('active') : setStatus('default');
                }
            });
        });
        if (mediaSingleElement) observer.observe(mediaSingleElement, {
            attributes: true,
            subtree: true,
            attributeFilter: [
                'data-has-focus'
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement,
        setStatus
    ]);
    if (!isDrafting && !activeParentIds.length) return null;
    const onClick = (e)=>{
        e.preventDefault();
        if (updateSubscriber) updateSubscriber.emit((0, $4Fc33.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: activeParentIds,
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            eventTarget: e.target,
            // use mediaSingle here to align with annotation viewed event dispatched in editor
            eventTargetType: 'mediaSingle',
            viewMethod: (0, $9XXFf.VIEW_METHOD).BADGE
        });
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $a61Rj.CommentBadgeNext), {
        onMouseEnter: ()=>setEntered(true),
        onMouseLeave: ()=>setEntered(false),
        status: entered ? 'entered' : status,
        onClick: onClick,
        mediaSingleElement: mediaSingleElement,
        ...rest
    });
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $cb7f1ffdadcf9370$var$Media extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), this.renderCard = (providers = {})=>{
            const { contextIdentifierProvider: contextIdentifierProvider } = providers;
            const { allowAltTextOnImages: allowAltTextOnImages, alt: alt, featureFlags: featureFlags, shouldOpenMediaViewer: allowMediaViewer, enableDownloadButton: enableDownloadButton, ssr: ssr, width: width, height: height, mediaSingleElement: mediaSingleElement, isDrafting: isDrafting = false } = this.props;
            const annotationMarks = this.props.isAnnotationMark ? this.props.marks.filter(this.props.isAnnotationMark) : undefined;
            const borderMark = this.props.marks.find(this.props.isBorderMark);
            const linkMark = this.props.marks.find(this.props.isLinkMark);
            const linkHref = linkMark?.attrs.href;
            const eventHandlers = linkHref ? undefined : this.props.eventHandlers;
            const shouldOpenMediaViewer = !linkHref && allowMediaViewer;
            const isInPageInclude = mediaSingleElement?.closest('[data-node-type="include"]');
            const isIncludeExcerpt = !!mediaSingleElement?.closest('.ak-excerpt-include');
            const showCommentBadge = !!annotationMarks && !isInPageInclude && !isIncludeExcerpt;
            return /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$MediaLink, {
                mark: linkMark,
                onClick: this.handleMediaLinkClickFn
            }, /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$MediaAnnotations, {
                marks: annotationMarks
            }, /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$MediaBorder, {
                mark: borderMark
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
                data: {
                    [(0, $eUaD0.MEDIA_CONTEXT)]: {
                        border: !!borderMark
                    }
                }
            }, (0, $eGOwo.fg)('platform_editor_add_media_from_url_rollout') && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $88noB.MediaBadges), {
                mediaElement: mediaSingleElement,
                mediaWidth: width,
                mediaHeight: height,
                useMinimumZIndex: true
            }, ({ visible: visible })=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, visible && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $avOy4.ExternalImageBadge), {
                    type: this.props.type,
                    url: this.props.type === 'external' ? this.props.url : undefined
                }), showCommentBadge && /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$CommentBadgeNextWrapper, {
                    marks: annotationMarks,
                    mediaSingleElement: mediaSingleElement,
                    isDrafting: isDrafting
                }))), !(0, $eGOwo.fg)('platform_editor_add_media_from_url_rollout') && showCommentBadge && /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$CommentBadgeWrapper, {
                marks: annotationMarks,
                mediaSingleElement: mediaSingleElement,
                width: width,
                height: height,
                isDrafting: isDrafting
            }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jMtSb.MediaCard), {
                contextIdentifierProvider: contextIdentifierProvider,
                ...this.props,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                eventHandlers: eventHandlers,
                alt: allowAltTextOnImages ? alt : undefined,
                featureFlags: featureFlags,
                shouldEnableDownloadButton: enableDownloadButton,
                ssr: ssr
            })))));
        }, this.handleMediaLinkClick = (event)=>{
            const { fireAnalyticsEvent: fireAnalyticsEvent, isLinkMark: isLinkMark, marks: marks } = this.props;
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).VISITED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).LINK,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $7ueoK.PLATFORM).WEB,
                    mode: (0, $7ueoK.MODE).RENDERER
                }
            });
            const linkMark = this.props.marks.find(this.props.isLinkMark);
            const linkHref = linkMark?.attrs.href;
            const handler = (0, $g9wjI.getEventHandler)(this.props.eventHandlers, 'link');
            if (handler) {
                const linkMark = marks.find(isLinkMark);
                handler(event, linkMark && linkHref);
            }
        };
        this.handleMediaLinkClickFn = this.handleMediaLinkClick.bind(this);
    }
    render() {
        const { providers: providers } = this.props;
        if (!providers) return this.renderCard();
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4sxxB.WithProviders), {
            providers: [
                'mediaProvider',
                'contextIdentifierProvider'
            ],
            providerFactory: providers,
            renderNode: this.renderCard
        });
    }
}
const $cb7f1ffdadcf9370$var$MediaWithDraftAnnotation = (props)=>{
    const { hoverDraftDocumentPosition: draftPosition } = (0, $e2m7L.useAnnotationRangeState)();
    const { dataAttributes: dataAttributes } = props;
    const pos = dataAttributes && dataAttributes['data-renderer-start-pos'];
    const [position, setPosition] = (0, $eJOHy.useState)();
    const [shouldApplyDraftAnnotation, setShouldApplyDraftAnnotation] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (pos === undefined) return;
        const posToCheck = (draftPosition?.from ?? 0) + 1;
        if (draftPosition !== null && posToCheck === pos) {
            setShouldApplyDraftAnnotation(true);
            setPosition(posToCheck);
        } else if (draftPosition === null && shouldApplyDraftAnnotation) {
            setShouldApplyDraftAnnotation(false);
            setPosition(undefined);
        }
    }, [
        draftPosition,
        pos,
        shouldApplyDraftAnnotation
    ]);
    const applyDraftAnnotation = props.allowAnnotationsDraftMode && shouldApplyDraftAnnotation && position !== undefined;
    const dataAttributesWithDraftAnnotation = (0, $eJOHy.useMemo)(()=>applyDraftAnnotation ? {
            ...dataAttributes,
            'data-annotation-draft-mark': true,
            'data-renderer-mark': true
        } : dataAttributes, [
        applyDraftAnnotation,
        dataAttributes
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$Media, {
        ...props,
        dataAttributes: dataAttributesWithDraftAnnotation,
        isDrafting: shouldApplyDraftAnnotation
    });
};
var $cb7f1ffdadcf9370$export$2e2bcd8739ae039 = $cb7f1ffdadcf9370$var$MediaWithDraftAnnotation;

});
parcelRegister("jhKIq", function(module, exports) {

$parcel$export(module.exports, "MediaSingleDimensionHelper", () => $4e85bca9ec1dc949$export$2b2737a2ef2f5b46);
$parcel$export(module.exports, "MediaWrapper", () => $4e85bca9ec1dc949$export$542000db99cecf28);
$parcel$export(module.exports, "MediaBorderGapFiller", () => $4e85bca9ec1dc949$export$e18e95249d813157);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $fNh22 = parcelRequire("fNh22");

var $19zEl = parcelRequire("19zEl");

var $bnh3n = parcelRequire("bnh3n");
function $4e85bca9ec1dc949$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $4e85bca9ec1dc949$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $4e85bca9ec1dc949$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7yBx7.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $7yBx7.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7yBx7.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $4e85bca9ec1dc949$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7yBx7.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $7yBx7.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7yBx7.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $4e85bca9ec1dc949$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $bnh3n.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $bnh3n.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $bnh3n.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $4e85bca9ec1dc949$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $4e85bca9ec1dc949$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $4e85bca9ec1dc949$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $bnh3n.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $bnh3n.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $4e85bca9ec1dc949$var$getWidthIfFullWidthMode(width, containerWidth) : $4e85bca9ec1dc949$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $4e85bca9ec1dc949$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $bnh3n.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $bnh3n.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
function $4e85bca9ec1dc949$var$calcMaxWidth(layout, containerWidth) {
    switch(layout){
        case 'wide':
            return (0, $bnh3n.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $bnh3n.calcBreakoutWidth)(layout, containerWidth);
        default:
            return '100%';
    }
}
function $4e85bca9ec1dc949$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $4e85bca9ec1dc949$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
function $4e85bca9ec1dc949$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.nodeType
 * @example
 */ var $4e85bca9ec1dc949$var$_ref = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $4e85bca9ec1dc949$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, nodeType: nodeType })=>{
    const calculatedWidth = $4e85bca9ec1dc949$export$c832331b07480714(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? $4e85bca9ec1dc949$export$d48e8f24f681763e(layout, width || 0, containerWidth) : $4e85bca9ec1dc949$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const calculatedMaxWidth = $4e85bca9ec1dc949$export$c832331b07480714(isExtendedResizeExperienceOn ? `${containerWidth}px` : $4e85bca9ec1dc949$var$calcMaxWidth(layout, containerWidth));
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $1NIU8.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $4e85bca9ec1dc949$var$_ref, "max-width:", (0, $fNh22.isSSR)() && !calculatedMaxWidth.endsWith('%') && (0, $eGOwo.fg)('platform_editor_fix_image_size_diff_during_ssr') ? Math.max(parseInt(calculatedWidth.replace('px', '')), parseInt(calculatedMaxWidth.replace('px', ''))) + 'px' : calculatedMaxWidth, ";", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $19zEl.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $4e85bca9ec1dc949$var$float(layout), ";margin:", $4e85bca9ec1dc949$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $19zEl.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $4e85bca9ec1dc949$var$isImageAligned(layout), ";");
};
const $4e85bca9ec1dc949$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $1NIU8.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $4e85bca9ec1dc949$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $1NIU8.css)("position:relative;", $4e85bca9ec1dc949$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-comment-badge='true'], [data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;>div{position:absolute;height:100%;}}");
const $4e85bca9ec1dc949$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $4e85bca9ec1dc949$export$9e3fd9f6215dd7b6(rest)
    }, children);
$4e85bca9ec1dc949$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $4e85bca9ec1dc949$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '1px'
        }
    });
};

});
parcelRegister("19zEl", function(module, exports) {

$parcel$export(module.exports, "shouldAddDefaultWrappedWidth", () => $b3204125fc08effb$export$7cd5aab2c4f1fb1e);
$parcel$export(module.exports, "nonWrappedLayouts", () => $b3204125fc08effb$export$607795ead6e50626);
$parcel$export(module.exports, "floatingLayouts", () => $b3204125fc08effb$export$7c0073a4d21b222d);
$parcel$export(module.exports, "isRichMediaInsideOfBlockNode", () => $b3204125fc08effb$export$55fb9d6810f2e04b);
$parcel$export(module.exports, "alignAttributes", () => $b3204125fc08effb$export$b2258912a400ba32);
$parcel$export(module.exports, "calculateSnapPoints", () => $b3204125fc08effb$export$de65085e667b4bf1);

var $BmspC = parcelRequire("BmspC");

var $7yBx7 = parcelRequire("7yBx7");

var $24wSW = parcelRequire("24wSW");
const $b3204125fc08effb$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $24wSW.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
const $b3204125fc08effb$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];
const $b3204125fc08effb$export$7c0073a4d21b222d = [
    'wrap-left',
    'wrap-right'
];
const $b3204125fc08effb$export$55fb9d6810f2e04b = (view, pos)=>{
    if (typeof pos !== 'number' || isNaN(pos) || !view) return false;
    const $pos = view.state.doc.resolve(pos);
    const { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } = view.state.schema.nodes;
    return !!(0, $BmspC.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn
    ]);
};
const $b3204125fc08effb$export$b2258912a400ba32 = (layout, oldAttrs, gridSize = 12, originalWidth, lineLength)=>{
    let width = oldAttrs.width;
    const oldLayout = oldAttrs.layout;
    const oldLayoutIsNonWrapped = $b3204125fc08effb$export$607795ead6e50626.indexOf(oldLayout) > -1;
    const newLayoutIsNonWrapped = $b3204125fc08effb$export$607795ead6e50626.indexOf(layout) > -1;
    const newLayoutIsWrapped = (0, $24wSW.wrappedLayouts).indexOf(layout) > -1;
    const oldLayoutIsWrapped = (0, $24wSW.wrappedLayouts).indexOf(oldLayout) > -1;
    if (oldLayoutIsNonWrapped && $b3204125fc08effb$export$7cd5aab2c4f1fb1e(layout, originalWidth, lineLength)) // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
    {
        if (!width || width >= 100 || oldLayout !== 'center' // == 'full-width' or 'wide'
        ) width = 50;
    } else if (layout !== oldLayout && [
        'full-width',
        'wide'
    ].indexOf(oldLayout) > -1) // 'full-width' -> 'center' or 'wide'
    // 'wide' -> 'center' or 'full-width'
    // unset width
    width = undefined;
    else if (width) {
        const cols = Math.round(width / 100 * gridSize);
        let targetCols = cols;
        if (oldLayoutIsWrapped && newLayoutIsNonWrapped) {
            // wrap -> center needs to align to even grid
            targetCols = Math.floor(targetCols / 2) * 2;
            width = undefined;
        } else if (oldLayoutIsNonWrapped && newLayoutIsWrapped) {
            // Can be here only if
            // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
            // AND
            // !originalWidth || !lineLength || small image
            // AND
            // width defined!
            // cannot resize to full column width, and cannot resize to 1 column
            if (cols <= 1) targetCols = 2;
            else if (cols >= gridSize) targetCols = 10;
        }
        if (targetCols !== cols) width = targetCols / gridSize * 100;
    }
    return {
        ...oldAttrs,
        layout: layout,
        width: width
    };
};
function $b3204125fc08effb$export$de65085e667b4bf1({ $pos: $pos, akEditorWideLayoutWidth: akEditorWideLayoutWidth, allowBreakoutSnapPoints: allowBreakoutSnapPoints, containerWidth: containerWidth, gridSize: gridSize, gridWidth: gridWidth, insideInlineLike: insideInlineLike, insideLayout: insideLayout, isVideoFile: isVideoFile, lineLength: lineLength, offsetLeft: offsetLeft, wrappedLayout: wrappedLayout }) {
    const snapTargets = [];
    for(let i = 0; i < gridWidth; i++){
        const pxFromColumns = (0, $24wSW.calcPxFromColumns)(i, lineLength, gridWidth);
        snapTargets.push(insideLayout ? pxFromColumns : pxFromColumns - offsetLeft);
    }
    // full width
    snapTargets.push(lineLength - offsetLeft);
    const columns = wrappedLayout || insideInlineLike ? 1 : 2;
    const minimumWidth = (0, $24wSW.calcPxFromColumns)(columns, lineLength, gridSize);
    let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
    if (!$pos) return snapPoints;
    snapPoints = isVideoFile ? snapPoints.filter((width)=>width > 320) : snapPoints;
    const isTopLevel = $pos.parent.type.name === 'doc';
    if (isTopLevel && allowBreakoutSnapPoints) {
        snapPoints.push(akEditorWideLayoutWidth);
        const fullWidthPoint = containerWidth - (0, $7yBx7.akEditorBreakoutPadding);
        if (fullWidthPoint > akEditorWideLayoutWidth) snapPoints.push(fullWidthPoint);
    }
    // EDM-1107: Ensure new snapPoints are sorted with existing points
    snapPoints = snapPoints.sort((a, b)=>a - b);
    return snapPoints;
}

});
parcelRegister("24wSW", function(module, exports) {

$parcel$export(module.exports, "calcPxFromColumns", () => $41c0bcab9a8da41b$export$1e3701608f0cee80);
$parcel$export(module.exports, "calcColumnsFromPx", () => $41c0bcab9a8da41b$export$10912f14d8d54640);
$parcel$export(module.exports, "calcPctFromPx", () => $41c0bcab9a8da41b$export$55ddb36b3404ec6d);
$parcel$export(module.exports, "wrappedLayouts", () => $41c0bcab9a8da41b$export$405baca3d8bc263d);
$parcel$export(module.exports, "calcMediaPxWidth", () => $41c0bcab9a8da41b$export$5e51fc02b9ada5af);

var $7yBx7 = parcelRequire("7yBx7");

var $1I3aa = parcelRequire("1I3aa");
const $41c0bcab9a8da41b$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $41c0bcab9a8da41b$export$adfc02948d64a4f2 = (layout)=>$41c0bcab9a8da41b$var$validWidthModes.indexOf(layout) > -1;
function $41c0bcab9a8da41b$export$1e3701608f0cee80(columns, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth / gridSize * columns - (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
}
function $41c0bcab9a8da41b$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}
function $41c0bcab9a8da41b$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
}
function $41c0bcab9a8da41b$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}
const $41c0bcab9a8da41b$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $41c0bcab9a8da41b$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil($41c0bcab9a8da41b$export$e70e278a1f662f8d(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $41c0bcab9a8da41b$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $41c0bcab9a8da41b$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $41c0bcab9a8da41b$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $7yBx7.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $7yBx7.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ($41c0bcab9a8da41b$export$405baca3d8bc263d.indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return Math.min(calculatedPctWidth, origWidth);
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && $41c0bcab9a8da41b$export$405baca3d8bc263d.indexOf(layout) !== -1) {
        const halfLineLength = Math.ceil((lineLength || width) / 2);
        return origWidth <= halfLineLength ? origWidth : halfLineLength;
    }
    return origWidth;
};
const $41c0bcab9a8da41b$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = $41c0bcab9a8da41b$export$e70e278a1f662f8d(gridWidth / 100, lineLength);
    const columnSpan = Math.round($41c0bcab9a8da41b$export$10912f14d8d54640(pxWidth, lineLength, gridSize));
    const alignedWidth = $41c0bcab9a8da41b$export$1e3701608f0cee80(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};

});
parcelRegister("1I3aa", function(module, exports) {

$parcel$export(module.exports, "MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH", () => $63e3275bb42d0987$export$5937600f4cc784f0);
$parcel$export(module.exports, "MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH", () => $63e3275bb42d0987$export$71d660e8ca5b8f73);
$parcel$export(module.exports, "MEDIA_SINGLE_SNAP_GAP", () => $63e3275bb42d0987$export$cd11d7d46412c89b);
$parcel$export(module.exports, "MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN", () => $63e3275bb42d0987$export$8c5ac0b0c62a3d21);
$parcel$export(module.exports, "MEDIA_SINGLE_GUTTER_SIZE", () => $63e3275bb42d0987$export$68d0abe4f03863fb);
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $63e3275bb42d0987$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $63e3275bb42d0987$export$da894f7669b4e67c);
$parcel$export(module.exports, "MEDIA_SINGLE_RESIZE_THROTTLE_TIME", () => $63e3275bb42d0987$export$e13825c38da2ce1);
$parcel$export(module.exports, "wrappedLayouts", () => $63e3275bb42d0987$export$405baca3d8bc263d);
$parcel$export(module.exports, "DEFAULT_ROUNDING_INTERVAL", () => $63e3275bb42d0987$export$4d41d008e9cd4f34);
$parcel$export(module.exports, "CAPTION_PLACEHOLDER_ID", () => $63e3275bb42d0987$export$b4b560efd3c61856);
const $63e3275bb42d0987$export$5937600f4cc784f0 = 24;
const $63e3275bb42d0987$export$71d660e8ca5b8f73 = 320;
const $63e3275bb42d0987$export$cd11d7d46412c89b = 3;
const $63e3275bb42d0987$export$71482734bb54ac3 = 10;
const $63e3275bb42d0987$export$fd2b09475ada41cc = 12;
const $63e3275bb42d0987$export$8c5ac0b0c62a3d21 = 8;
const $63e3275bb42d0987$export$68d0abe4f03863fb = $63e3275bb42d0987$export$fd2b09475ada41cc * 2;
const $63e3275bb42d0987$export$d722b7527b1834a8 = 250;
const $63e3275bb42d0987$export$da894f7669b4e67c = 200;
const $63e3275bb42d0987$export$e13825c38da2ce1 = 100;
var $63e3275bb42d0987$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $63e3275bb42d0987$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $63e3275bb42d0987$export$4d41d008e9cd4f34 = 0.5;
const $63e3275bb42d0987$export$b4b560efd3c61856 = 'caption-placeholder';

});




parcelRegister("jMtSb", function(module, exports) {

$parcel$export(module.exports, "mediaIdentifierMap", () => $82c3186f94959555$export$7da2d00ddd5627a6);
$parcel$export(module.exports, "getClipboardAttrs", () => $82c3186f94959555$export$92bef806f5be5d7c);
$parcel$export(module.exports, "MediaCard", () => $82c3186f94959555$export$a6543a2e3828db2c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fpoq4 = parcelRequire("fpoq4");

var $dcbV5 = parcelRequire("dcbV5");
var $5Ittp = parcelRequire("5Ittp");
var $bmpmu = parcelRequire("bmpmu");

var $93R6D = parcelRequire("93R6D");

var $5s6bt = parcelRequire("5s6bt");
const $82c3186f94959555$export$7da2d00ddd5627a6 = new Map();
const $82c3186f94959555$export$e689a46890560dbd = (doc)=>{
    if (!doc) return [];
    return (0, $fpoq4.filter)(doc, (node)=>node.type === 'media').reduce((identifierList, mediaNode)=>{
        if (mediaNode.attrs) {
            const { type: type, url: dataURI, id: id } = mediaNode.attrs;
            if (type === 'file' && id) identifierList.push({
                mediaItemType: 'file',
                id: id
            });
            else if (type === 'external' && dataURI) identifierList.push({
                mediaItemType: 'external-image',
                dataURI: dataURI,
                name: dataURI
            });
        }
        return identifierList;
    }, []);
};
class $82c3186f94959555$export$cfff5eb155a82d30 extends (0, $eJOHy.Component) {
    async componentDidMount() {
        const { rendererContext: rendererContext, contextIdentifierProvider: contextIdentifierProvider, id: id, url: url, collection: collectionName } = this.props;
        if (contextIdentifierProvider) this.setState({
            contextIdentifierProvider: await contextIdentifierProvider
        });
        const nodeIsInCache = id && $82c3186f94959555$export$7da2d00ddd5627a6.has(id) || url && $82c3186f94959555$export$7da2d00ddd5627a6.has(url);
        if (rendererContext && rendererContext.adDoc && !nodeIsInCache) $82c3186f94959555$export$e689a46890560dbd(rendererContext.adDoc).forEach((identifier)=>{
            if (identifier.mediaItemType === 'file' && identifier.id === id) $82c3186f94959555$export$7da2d00ddd5627a6.set(identifier.id, {
                ...identifier,
                collectionName: collectionName
            });
            else if (identifier.mediaItemType === 'external-image') $82c3186f94959555$export$7da2d00ddd5627a6.set(identifier.dataURI, identifier);
        });
        if (id) this.saveFileState(id);
    }
    componentDidUpdate(prevProps) {
        const { id: oldId } = prevProps;
        if (this.props.id && oldId !== this.props.id) this.saveFileState(this.props.id);
    }
    componentWillUnmount() {
        const { id: id, url: dataURI } = this.props;
        if (id) $82c3186f94959555$export$7da2d00ddd5627a6.delete(id);
        else if (dataURI) $82c3186f94959555$export$7da2d00ddd5627a6.delete(dataURI);
    }
    renderExternal(shouldOpenMediaViewer) {
        const { cardDimensions: cardDimensions, resizeMode: resizeMode, appearance: appearance, url: url, imageStatus: imageStatus, disableOverlay: disableOverlay, alt: alt, featureFlags: featureFlags, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes } = this.props;
        if (imageStatus === 'loading' || !url) return this.renderLoadingCard();
        const identifier = {
            dataURI: url,
            name: url,
            mediaItemType: 'external-image'
        };
        // we need this statement for the mandatory mediaClientConfig below
        const mediaClientConfig = mediaClient?.mediaClientConfig;
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ...dataAttributes,
            "data-node-type": "media",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dcbV5.default), {
                // TODO: MPT-315 - clean up after we move mediaClientConfig into FileIdentifier
                // context is not really used when the type is external and we want to render the component asap
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mediaClientConfig: mediaClientConfig,
                alt: alt,
                identifier: identifier,
                dimensions: cardDimensions,
                appearance: appearance,
                resizeMode: resizeMode,
                disableOverlay: disableOverlay,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($82c3186f94959555$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                ssr: ssr?.mode,
                shouldHideTooltip: false
            })
        }));
    }
    render() {
        const { contextIdentifierProvider: contextIdentifierProvider, fileState: fileState } = this.state;
        const { id: id, alt: alt, type: type, collection: collection, occurrenceKey: occurrenceKey, cardDimensions: cardDimensions, resizeMode: resizeMode, disableOverlay: disableOverlay, useInlinePlayer: useInlinePlayer, originalDimensions: originalDimensions, shouldOpenMediaViewer: forceOpenMediaViewer, featureFlags: featureFlags, shouldEnableDownloadButton: shouldEnableDownloadButton, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes } = this.props;
        const isMobile = false;
        const shouldPlayInline = useInlinePlayer !== undefined ? useInlinePlayer : true;
        const isInlinePlayer = isMobile ? false : shouldPlayInline;
        const onCardClick = this.getOnCardClickCallback(isInlinePlayer);
        const shouldOpenMediaViewer = typeof forceOpenMediaViewer === 'boolean' ? forceOpenMediaViewer : !isMobile && !onCardClick;
        if (type === 'external') return this.renderExternal(shouldOpenMediaViewer);
        if (type === 'link') return null;
        const mediaClientConfig = !!ssr ? ssr.config : mediaClient?.mediaClientConfig;
        if (!mediaClientConfig || !id) return this.renderLoadingCard();
        if (!id || type !== 'file') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5Ittp.CardError), {
            dimensions: cardDimensions
        });
        const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
        const identifier = {
            id: id,
            mediaItemType: 'file',
            collectionName: collection,
            occurrenceKey: occurrenceKey
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ...$82c3186f94959555$export$92bef806f5be5d7c({
                id: id,
                alt: alt,
                collection: collection,
                contextIdentifierProvider: contextIdentifierProvider,
                originalDimensions: originalDimensions,
                fileState: fileState
            }),
            ...dataAttributes,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dcbV5.default), {
                identifier: identifier,
                alt: alt,
                contextId: contextId,
                mediaClientConfig: mediaClientConfig,
                dimensions: cardDimensions,
                originalDimensions: originalDimensions,
                onClick: onCardClick,
                resizeMode: resizeMode,
                isLazy: !isMobile,
                disableOverlay: disableOverlay,
                useInlinePlayer: isInlinePlayer,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($82c3186f94959555$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                shouldEnableDownloadButton: shouldEnableDownloadButton,
                ssr: ssr?.mode,
                shouldHideTooltip: isMobile
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {}, this.saveFileState = async (id)=>{
            const { collection: collectionName, mediaClient: mediaClient } = this.props;
            const options = {
                collectionName: collectionName
            };
            try {
                if (mediaClient) {
                    const fileState = await mediaClient.file.getCurrentState(id, options);
                    this.setState({
                        fileState: fileState
                    });
                }
            } catch (error) {
            // do not set state on error
            }
        }, this.renderLoadingCard = ()=>{
            const { cardDimensions: cardDimensions } = this.props;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bmpmu.CardLoading), {
                dimensions: cardDimensions,
                interactionName: "renderer-media-card-loading"
            });
        }, /**
	 * We want to call provided `eventHandlers.media.onClick` when it's provided,
	 * but we also don't want to call it when it's a video and inline video player is enabled.
	 * This is due to consumers normally process this onClick call by opening media viewer and
	 * we don't want that to happened described above text.
	 */ this.getOnCardClickCallback = (isInlinePlayer)=>{
            const { eventHandlers: eventHandlers } = this.props;
            if (eventHandlers && eventHandlers.media && eventHandlers.media.onClick) return (result, analyticsEvent)=>{
                const isVideo = result.mediaItemDetails && result.mediaItemDetails.mediaType === 'video';
                const isVideoWithInlinePlayer = isInlinePlayer && isVideo;
                if (!isVideoWithInlinePlayer && eventHandlers && eventHandlers.media && eventHandlers.media.onClick) eventHandlers.media.onClick(result, analyticsEvent);
            };
            return undefined;
        };
    }
}
const $82c3186f94959555$export$92bef806f5be5d7c = ({ id: id, alt: alt, collection: collection, contextIdentifierProvider: contextIdentifierProvider, originalDimensions: originalDimensions, fileState: fileState })=>{
    const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
    const width = originalDimensions && originalDimensions.width;
    const height = originalDimensions && originalDimensions.height;
    let fileName = 'file'; // default name is needed for Confluence
    let fileSize = 1;
    let fileMimeType = '';
    if (fileState && fileState.status !== 'error') {
        fileSize = fileState.size;
        fileName = fileState.name;
        fileMimeType = fileState.mimeType;
    }
    return {
        'data-context-id': contextId,
        'data-type': 'file',
        'data-node-type': 'media',
        'data-width': width,
        'data-height': height,
        'data-id': id,
        'data-collection': collection,
        'data-file-name': fileName,
        'data-file-size': fileSize,
        'data-file-mime-type': fileMimeType,
        'data-alt': alt
    };
};
const $82c3186f94959555$export$fae4803d1ca121c8 = (props)=>{
    const mediaClient = (0, $eJOHy.useContext)((0, $93R6D.MediaClientContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)($82c3186f94959555$export$cfff5eb155a82d30, {
        ...props,
        mediaClient: mediaClient
    });
};
const $82c3186f94959555$export$a6543a2e3828db2c = (0, $5s6bt.withImageLoader)($82c3186f94959555$export$fae4803d1ca121c8);

});
parcelRegister("fpoq4", function(module, exports) {

$parcel$export(module.exports, "filter", () => $01d8b182e291a8c9$export$3dea766d36a8935f);

var $0mclG = parcelRequire("0mclG");
function $01d8b182e291a8c9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $0mclG.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});

parcelRegister("dcbV5", function(module, exports) {

$parcel$export(module.exports, "default", () => $440702c4dbb2b839$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $bmpmu = parcelRequire("bmpmu");

var $6FOAB = parcelRequire("6FOAB");
const $440702c4dbb2b839$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});
const $440702c4dbb2b839$var$CardLoadingWithContext = ()=>{
    const props = (0, $eJOHy.useContext)($440702c4dbb2b839$var$MediaCardContext);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bmpmu.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

const $440702c4dbb2b839$var$MediaCardWithMediaClientProvider = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("bEb6t")).then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($440702c4dbb2b839$var$CardLoadingWithContext, {})
});
const $440702c4dbb2b839$var$CardLoader = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6FOAB.default), {
        name: "media-card",
        mode: "list",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($440702c4dbb2b839$var$MediaCardContext.Provider, {
            value: props,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($440702c4dbb2b839$var$MediaCardWithMediaClientProvider, {
                ...props
            })
        })
    });
};
$440702c4dbb2b839$var$CardLoader.preload = ()=>$440702c4dbb2b839$var$MediaCardWithMediaClientProvider.preload();
var $440702c4dbb2b839$export$2e2bcd8739ae039 = $440702c4dbb2b839$var$CardLoader;

});
parcelRegister("bmpmu", function(module, exports) {

$parcel$export(module.exports, "CardLoading", () => $db1ec8ca7bffe853$export$5d25853fd6bdf402);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $28sr0 = parcelRequire("28sr0");

var $lWr6W = parcelRequire("lWr6W");

var $7ep4S = parcelRequire("7ep4S");
class $db1ec8ca7bffe853$export$5d25853fd6bdf402 extends (0, $eJOHy.Component) {
    render() {
        const { dimensions: dimensionsProp, testId: testId, interactionName: interactionName } = this.props;
        const dimensions = (0, $28sr0.getDimensionsWithDefault)(dimensionsProp);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lWr6W.Wrapper), {
            "data-testid": testId || 'media-card-loading',
            "data-test-loading": true,
            dimensions: dimensions,
            "data-vc": "media-card-loading",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                interactionName: interactionName || 'media-card-loading'
            })
        });
    }
}

});
parcelRegister("28sr0", function(module, exports) {

$parcel$export(module.exports, "getDimensionsWithDefault", () => $61071ab5121234d6$export$36acad525b1fb57b);
const $61071ab5121234d6$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};

});

parcelRegister("lWr6W", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $e9eebb219ee337c1$export$e6dfd72ab29f8598);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $5Jy1o = parcelRequire("5Jy1o");
const $e9eebb219ee337c1$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $5Jy1o.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};

});
parcelRegister("5Jy1o", function(module, exports) {

$parcel$export(module.exports, "wrapperStyles", () => $f348d9bfdd9d67d9$export$491e6397d7c1480b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $iYfp4 = parcelRequire("iYfp4");

const $f348d9bfdd9d67d9$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $1NIU8.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $iYfp4.center), {
        background: `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`,
        color: `var(--ds-icon, ${(0, $7bb4c1736002a04a$export$8754fc7e6d8b3000)})`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $iYfp4.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });

});
parcelRegister("iYfp4", function(module, exports) {

$parcel$export(module.exports, "ellipsis", () => $63bf6031dd7cc765$export$a5b94313d6908893);
$parcel$export(module.exports, "size", () => $63bf6031dd7cc765$export$346677f925de839c);
$parcel$export(module.exports, "center", () => $63bf6031dd7cc765$export$3481c78889e8fbe8);
$parcel$export(module.exports, "borderRadius", () => $63bf6031dd7cc765$export$7a57f79000377ca2);

var $IW7jS = parcelRequire("IW7jS");
const $63bf6031dd7cc765$export$a5b94313d6908893 = (maxWidth = '100%')=>{
    const unit = typeof maxWidth === 'number' ? 'px' : '';
    return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
const $63bf6031dd7cc765$export$346677f925de839c = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
const $63bf6031dd7cc765$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $63bf6031dd7cc765$export$d31af2dc8039efd3 = (top = 0, left = 0)=>`
  position: absolute;
  top: ${top}px;
  left: ${left}px;
`;
const $63bf6031dd7cc765$export$7a57f79000377ca2 = `
  border-radius: ${(0, $IW7jS.borderRadius)()}px;
`;
const $63bf6031dd7cc765$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${(0, $IW7jS.borderRadius)()}px;
  border-bottom-right-radius: ${(0, $IW7jS.borderRadius)()}px;
`;
const $63bf6031dd7cc765$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

});

var $7bb4c1736002a04a$exports = {};

$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';




parcelRegister("bEb6t", function(module, exports) {

let $87ac0b0ffd163c7e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $87ac0b0ffd163c7e$var$load("76n7a"),
    $87ac0b0ffd163c7e$var$load("l253H"),
    $87ac0b0ffd163c7e$var$load("ffQaD"),
    $87ac0b0ffd163c7e$var$load("kvRbA"),
    $87ac0b0ffd163c7e$var$load("7Kgk2")
]).then(()=>parcelRequire('a7bVf'));

});


parcelRegister("5Ittp", function(module, exports) {

$parcel$export(module.exports, "CardError", () => $ab93af2b85cbe70e$export$f7f7efdefcc02999);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $s1DYz = parcelRequire("s1DYz");

var $lWr6W = parcelRequire("lWr6W");

var $28sr0 = parcelRequire("28sr0");
class $ab93af2b85cbe70e$export$f7f7efdefcc02999 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            size: 'medium'
        };
    }
    render() {
        const dimensions = (0, $28sr0.getDimensionsWithDefault)(this.props.dimensions);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lWr6W.Wrapper), {
            dimensions: dimensions,
            children: this.icon
        });
    }
    get icon() {
        const { size: size } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $s1DYz.ErrorIcon), {
            size: size
        });
    }
}

});
parcelRegister("s1DYz", function(module, exports) {

$parcel$export(module.exports, "ErrorIcon", () => $1bf51cf07c3bbe77$export$19bc16ee58e19b3d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $jNOdV = parcelRequire("jNOdV");

var $fetIp = parcelRequire("fetIp");
class $1bf51cf07c3bbe77$export$19bc16ee58e19b3d extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            size: 'small'
        };
    }
    render() {
        const { size: size } = this.props;
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: (0, $fetIp.errorIconWrapperStyles)
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jNOdV))), {
            color: "currentColor",
            label: "Error",
            LEGACY_size: size
        })));
    }
}

});
parcelRegister("jNOdV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0bf07842bc2fe365de9b1d85cb30465>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6a98d42b8b0ed3d$var$_react = $e6a98d42b8b0ed3d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e6a98d42b8b0ed3d$var$_warning = $e6a98d42b8b0ed3d$var$_interopRequireDefault((parcelRequire("dUhgd")));

var $e6a98d42b8b0ed3d$var$_warning2 = $e6a98d42b8b0ed3d$var$_interopRequireDefault((parcelRequire("78Hx3")));
function $e6a98d42b8b0ed3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "EditorWarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6a98d42b8b0ed3d$var$WarningIcon = (props)=>/*#__PURE__*/ $e6a98d42b8b0ed3d$var$_react.default.createElement($e6a98d42b8b0ed3d$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $e6a98d42b8b0ed3d$var$_warning2.default
    }, props));
$e6a98d42b8b0ed3d$var$WarningIcon.Name = 'WarningIconMigration';
var $e6a98d42b8b0ed3d$var$_default = module.exports.default = $e6a98d42b8b0ed3d$var$WarningIcon;

});
parcelRegister("78Hx3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $532b0c56cbaaba87$var$_react = $532b0c56cbaaba87$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $532b0c56cbaaba87$var$_warning = $532b0c56cbaaba87$var$_interopRequireDefault((parcelRequire("dUhgd")));
function $532b0c56cbaaba87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $532b0c56cbaaba87$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $532b0c56cbaaba87$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props, {
        newIcon: $532b0c56cbaaba87$var$_warning.default
    }));
$532b0c56cbaaba87$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $532b0c56cbaaba87$var$_default = module.exports.default = $532b0c56cbaaba87$var$EditorWarningIcon;

});


parcelRegister("fetIp", function(module, exports) {

$parcel$export(module.exports, "errorIconWrapperStyles", () => $0802496f61d134d4$export$8dcf6b831a37de79);
function $0802496f61d134d4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0802496f61d134d4$export$8dcf6b831a37de79 = {
    name: "1fo963f",
    styles: "display:flex;color:var(--ds-icon-warning, #ff991f)"
};

});



parcelRegister("5s6bt", function(module, exports) {

$parcel$export(module.exports, "withImageLoader", () => $e51a33182b24142b$export$9b0f795b2e33f057);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $e51a33182b24142b$export$3a0bcc6ff2e20f36 = (Wrapped)=>class WithImageLoader extends (0, $eJOHy.Component) {
        /**
		 *
		 * @example
		 */ componentDidMount() {
            this.fetchImage(this.props);
        }
        /**
		 *
		 * @param nextProps
		 * @example
		 */ // Ignored via go/ees005
        // eslint-disable-next-line react/no-unsafe
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(nextProps);
            }
        }
        /**
		 *
		 * @example
		 */ componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        /**
		 *
		 * @param root0
		 * @param root0.url
		 * @example
		 */ fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        /**
		 *
		 * @example
		 */ render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $e51a33182b24142b$var$withImageLoaderNew = (Wrapped)=>class WithImageLoader extends (0, $eJOHy.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        componentDidUpdate(newProps) {
            if (newProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(newProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $e51a33182b24142b$export$9b0f795b2e33f057 = (Wrapped)=>{
    return $e51a33182b24142b$var$withImageLoaderNew(Wrapped);
};

});


parcelRegister("9Ybet", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $0340e326d8501f19$export$bad3c41dd33cb4bc);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $0340e326d8501f19$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $0340e326d8501f19$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $0340e326d8501f19$export$aa000893c5e2b9c2 = {
    // gray
    /** gray - subtle */ ['#091E4224']: "var(--ds-border, #091E4224)",
    /** gray */ ['#758195']: "var(--ds-border-bold, #758195)",
    /** gray - bold */ ['#172B4D']: "var(--ds-text, #172B4D)"
};

});

parcelRegister("9XXFf", function(module, exports) {

$parcel$export(module.exports, "RESOLVE_METHOD", () => $b3cdb4a4cbb698e4$export$ecd1fed429542b49);
$parcel$export(module.exports, "VIEW_METHOD", () => $b3cdb4a4cbb698e4$export$9cf3651d97128b9c);
var $b3cdb4a4cbb698e4$export$ecd1fed429542b49 = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}({});
var $b3cdb4a4cbb698e4$export$9cf3651d97128b9c = /*#__PURE__*/ function(VIEW_METHOD) {
    VIEW_METHOD["BADGE"] = "badge";
    VIEW_METHOD["COMMENT_BUTTON"] = "commentButton";
    return VIEW_METHOD;
}({});

});

parcelRegister("11jfh", function(module, exports) {

$parcel$export(module.exports, "CommentBadge", () => $5ce53efbf51888c4$export$ef88b752358da42);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $3s8bj = parcelRequire("3s8bj");

var $abjs4 = parcelRequire("abjs4");

var $7yBx7 = parcelRequire("7yBx7");

var $gDKBr = parcelRequire("gDKBr");

var $04OD1 = parcelRequire("04OD1");

var $k71qx = parcelRequire("k71qx");

var $kH7By = parcelRequire("kH7By");
const $5ce53efbf51888c4$var$commentBadgeWrapper = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'absolute',
    // closest parent element with position relative is .resizer-hover-zone, which includes 10px padding
    right: '2px',
    top: '2px',
    borderRadius: '3px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $7yBx7.akEditorUnitZIndex) * 10
});
const $5ce53efbf51888c4$var$commentBadgeEditorOverrides = (badgeOffsetRight)=>/*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        right: badgeOffsetRight,
        zIndex: 100
    });
const $5ce53efbf51888c4$export$1019384fb8540123 = (width, height)=>{
    // width is the original width of image, not resized or currently rendered to user. Defaulting to medium for now
    return width && width < 70 || height && height < 70 ? 'small' : 'medium';
};
const $5ce53efbf51888c4$export$ef88b752358da42 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ intl: intl, width: width, height: height, status: status = 'default', mediaSingleElement: mediaSingleElement, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, badgeOffsetRight: badgeOffsetRight }, ref)=>{
    const [badgeSize, setBadgeSize] = (0, $eJOHy.useState)($5ce53efbf51888c4$export$1019384fb8540123(width, height));
    const title = intl.formatMessage((0, $kH7By.commentMessages).viewCommentsOnMedia);
    (0, $eJOHy.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setBadgeSize($5ce53efbf51888c4$export$1019384fb8540123(width, height));
        }));
        if (mediaSingleElement instanceof HTMLElement) observer.observe(mediaSingleElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement
    ]);
    const badgeDimensions = badgeSize === 'medium' ? '24px' : '16px';
    const colourToken = (0, $eJOHy.useMemo)(()=>{
        switch(status){
            case 'active':
                return "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)";
            case 'entered':
                return "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)";
            default:
                return "var(--ds-background-accent-yellow-subtlest, #FFF7D6)";
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: ref,
        css: badgeOffsetRight ? [
            $5ce53efbf51888c4$var$commentBadgeWrapper,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            $5ce53efbf51888c4$var$commentBadgeEditorOverrides(badgeOffsetRight)
        ] : $5ce53efbf51888c4$var$commentBadgeWrapper,
        // This is needed so that mediaWrapperStyle in editor/editor-common/src/ui/MediaSingle/styled.tsx
        // can target the correct div
        "data-comment-badge": "true"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        position: "top",
        content: title
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $abjs4.default), {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: badgeDimensions,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: badgeDimensions,
            background: colourToken,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center'
        },
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        iconAfter: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gDKBr))), {
            label: title,
            spacing: "spacious",
            color: "currentColor",
            LEGACY_size: badgeSize,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($04OD1)))
        })
    })));
});

});
parcelRegister("gDKBr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1d470387d991694$var$_react = $c1d470387d991694$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c1d470387d991694$var$_baseNew = $c1d470387d991694$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c1d470387d991694$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1d470387d991694$var$CommentIcon = (props)=>/*#__PURE__*/ $c1d470387d991694$var$_react.default.createElement($c1d470387d991694$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$c1d470387d991694$var$CommentIcon.displayName = 'CommentIcon';
var $c1d470387d991694$var$_default = module.exports.default = $c1d470387d991694$var$CommentIcon;

});

parcelRegister("04OD1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00e7a599837ddc3e$var$_react = $00e7a599837ddc3e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $00e7a599837ddc3e$var$_comment = $00e7a599837ddc3e$var$_interopRequireDefault((parcelRequire("gDKBr")));
function $00e7a599837ddc3e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $00e7a599837ddc3e$var$CommentIcon = (props)=>/*#__PURE__*/ $00e7a599837ddc3e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $00e7a599837ddc3e$var$_comment.default
    }));
$00e7a599837ddc3e$var$CommentIcon.displayName = 'CommentIcon';
var $00e7a599837ddc3e$var$_default = module.exports.default = $00e7a599837ddc3e$var$CommentIcon;

});

parcelRegister("kH7By", function(module, exports) {

$parcel$export(module.exports, "commentMessages", () => $a53c9034f68ab7f9$export$4c0d145df60cfb04);

var $7qGN1 = parcelRequire("7qGN1");
const $a53c9034f68ab7f9$export$4c0d145df60cfb04 = (0, $7qGN1.defineMessages)({
    addCommentOnMedia: {
        id: 'fabric.editor.addCommentOnMedia',
        defaultMessage: 'Add comment',
        description: 'Add a comment for this media (image/video)'
    },
    viewCommentsOnMedia: {
        id: 'fabric.editor.viewCommentOnMedia',
        defaultMessage: 'View comments',
        description: 'View a existing comment for this media (image/video)'
    },
    viewAndAddCommentsOnMedia: {
        id: 'fabric.editor.viewAndAddCommentsOnMedia',
        defaultMessage: 'View and add comments',
        description: 'View and add comments for this image'
    }
});

});


parcelRegister("a61Rj", function(module, exports) {

$parcel$export(module.exports, "CommentBadgeNext", () => $3d21c0f76897116c$export$d5da84b0136a0cc4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $gDKBr = parcelRequire("gDKBr");

var $04OD1 = parcelRequire("04OD1");

var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $kH7By = parcelRequire("kH7By");
const $3d21c0f76897116c$var$baseStyles = (0, $1DXK0.xcss)({
    borderRadius: 'border.radius'
});
const $3d21c0f76897116c$var$mediumBadgeStyles = (0, $1DXK0.xcss)({
    height: 'space.300',
    width: 'space.300'
});
const $3d21c0f76897116c$export$d5da84b0136a0cc4 = ({ status: status = 'default', onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const intl = (0, $lRq8t.default)();
    const title = intl.formatMessage((0, $kH7By.commentMessages).viewCommentsOnMedia);
    const colourToken = (0, $eJOHy.useMemo)(()=>{
        switch(status){
            case 'active':
                return 'color.background.accent.yellow.subtlest.pressed';
            case 'entered':
                return 'color.background.accent.yellow.subtlest.hovered';
            default:
                return 'color.background.accent.yellow.subtlest';
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        position: "top",
        content: title,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQP4O.default), {
            xcss: [
                $3d21c0f76897116c$var$baseStyles,
                $3d21c0f76897116c$var$mediumBadgeStyles
            ],
            padding: "space.0",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            backgroundColor: colourToken,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gDKBr))), {
                label: title,
                spacing: "spacious",
                color: "currentColor",
                LEGACY_size: "medium",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($04OD1)))
            })
        })
    });
};

});

parcelRegister("avOy4", function(module, exports) {

$parcel$export(module.exports, "ExternalImageBadge", () => $fc1bed99f2b44345$export$66bf2ed7a5d4691f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $7kJQm = parcelRequire("7kJQm");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $aGtA3 = parcelRequire("aGtA3");
const $fc1bed99f2b44345$var$baseStyles = (0, $1DXK0.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    cursor: 'pointer'
});
const $fc1bed99f2b44345$var$NO_EXTERNAL_BADGE_HOSTS = [
    'atlassian.com',
    'loom.com'
];
const $fc1bed99f2b44345$export$babb68fb5c212c90 = (url)=>{
    if (!url) return false;
    // Check if URL is valid
    try {
        new URL(url);
    } catch  {
        return false;
    }
    const parsedUrl = new URL(url || '');
    const { hostname: hostname, pathname: pathname, protocol: protocol } = parsedUrl;
    if (protocol === 'data:') return pathname?.startsWith('image/');
    return Boolean(hostname && $fc1bed99f2b44345$var$NO_EXTERNAL_BADGE_HOSTS.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
};
const $fc1bed99f2b44345$export$66bf2ed7a5d4691f = ({ type: type, url: url })=>{
    const intl = (0, $lRq8t.default)();
    const message = intl.formatMessage((0, $aGtA3.externalMediaMessages).externalMediaFile);
    if (type !== 'external' || $fc1bed99f2b44345$export$babb68fb5c212c90(url)) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
        padding: "space.050",
        xcss: $fc1bed99f2b44345$var$baseStyles,
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                "data-testid": "external-image-badge"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                content: message,
                position: "top",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kJQm))), {
                    LEGACY_size: "small",
                    label: message
                })
            })
        ]
    });
};

});
parcelRegister("aGtA3", function(module, exports) {

$parcel$export(module.exports, "externalMediaMessages", () => $6d685c4974759cb5$export$8e36294abfabe45e);

var $7qGN1 = parcelRequire("7qGN1");
const $6d685c4974759cb5$export$8e36294abfabe45e = (0, $7qGN1.defineMessages)({
    externalMediaFile: {
        id: 'fabric.editor.externalMediaFile',
        defaultMessage: 'External media file',
        description: 'External media file'
    }
});

});


parcelRegister("88noB", function(module, exports) {

$parcel$export(module.exports, "MediaBadges", () => $e2b99d7830d902d4$export$6a31fc38737d0e58);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $e2b99d7830d902d4$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT = 200;
const $e2b99d7830d902d4$var$containerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    gap: 'space.025',
    zIndex: 'card',
    height: 'fit-content',
    width: 'fit-content',
    margin: 'space.075'
});
// The above styles are used for both editor and renderer, and in renderer the
// document body is the main scroll area. This means it overscrolls the primary
// toolbar, where the z-index is "2". We have to hack in our own z-index less
// than that to ensure our badge appears under the toolbar when scrolled.
const $e2b99d7830d902d4$var$hackedZIndexStyles = (0, $1DXK0.xcss)({
    // @ts-ignore
    zIndex: '1'
});
const $e2b99d7830d902d4$var$resizeOffsetStyles = (0, $1DXK0.xcss)({
    right: 'space.150'
});
const $e2b99d7830d902d4$var$getBadgeVisible = (width, height)=>{
    return width && width < $e2b99d7830d902d4$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT || height && height < $e2b99d7830d902d4$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT ? false : true;
};
const $e2b99d7830d902d4$export$6a31fc38737d0e58 = ({ children: children, mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex = false })=>{
    const [visible, setVisible] = (0, $eJOHy.useState)($e2b99d7830d902d4$var$getBadgeVisible(mediaWidth, mediaHeight));
    (0, $eJOHy.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setVisible($e2b99d7830d902d4$var$getBadgeVisible(width, height));
        }));
        if (mediaElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        observer.observe(mediaElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaElement
    ]);
    if (typeof children === 'function') children = children({
        visible: visible
    });
    if (!mediaElement || (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.count(children) === 0) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        as: "div",
        testId: "media-badges",
        "data-media-badges": "true",
        contentEditable: false,
        xcss: [
            $e2b99d7830d902d4$var$containerStyles,
            useMinimumZIndex && $e2b99d7830d902d4$var$hackedZIndexStyles,
            extendedResizeOffset && $e2b99d7830d902d4$var$resizeOffsetStyles
        ],
        children: children
    });
};

});


parcelRegister("2FwjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $85dfa6ab83027e14$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1n5AE = parcelRequire("1n5AE");

var $8TCRV = parcelRequire("8TCRV");

var $jgJtD = parcelRequire("jgJtD");

var $eGOwo = parcelRequire("eGOwo");
class $85dfa6ab83027e14$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    render() {
        const numChildren = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.count(this.props.children);
        let content;
        const mediaGroupProps = (0, $eGOwo.fg)('platform_editor_fix_vc90_bug_with_files') ? (0, $jgJtD.VcMediaWrapperProps) : {};
        if (numChildren === 1) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const card = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(this.props.children)[0];
            switch(card.props.type){
                case 'file':
                    content = this.renderSingleFile(card);
                    break;
                case 'link':
                    content = null;
                    break;
                default:
                    content = this.renderSingleLink(card);
            }
        } else content = this.renderStrip();
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: "MediaGroup",
                ...mediaGroupProps,
                children: content
            })
        });
    }
    renderSingleFile(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
            resizeMode: 'stretchy-fit',
            cardDimensions: (0, $1n5AE.defaultImageCardDimensions),
            useInlinePlayer: false,
            featureFlags: this.props.featureFlags,
            enableDownloadButton: this.props.enableDownloadButton
        });
    }
    renderSingleLink(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
            appearance: 'auto',
            featureFlags: this.props.featureFlags
        });
    }
    cloneFileCard(child, surroundingItems) {
        const cardClickHandler = this.props && this.props.eventHandlers && this.props.eventHandlers.media && this.props.eventHandlers.media.onClick;
        const onClick = cardClickHandler ? this.onMediaClick(cardClickHandler, child, surroundingItems) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
            useInlinePlayer: false,
            eventHandlers: {
                ...child.props.eventHandlers,
                media: {
                    onClick: onClick
                }
            },
            featureFlags: this.props.featureFlags,
            enableDownloadButton: this.props.enableDownloadButton
        });
    }
    renderStrip() {
        const { children: children } = this.props;
        const { animate: animate, offset: offset } = this.state;
        const childIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>{
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) return this.mapMediaPropsToIdentifier(child.props);
        });
        const surroundingItems = (childIdentifiers || []).filter((identifier)=>!!identifier);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8TCRV.FilmstripView), {
            animate: animate,
            offset: offset,
            onSize: this.handleSize,
            onScroll: this.handleScroll,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (rawChild)=>{
                const child = rawChild;
                switch(child.props.type){
                    case 'file':
                        return this.cloneFileCard(child, surroundingItems);
                    case 'link':
                        return null;
                    default:
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
                            featureFlags: this.props.featureFlags,
                            enableDownloadButton: this.props.enableDownloadButton
                        });
                }
            })
        });
    }
    mapMediaPropsToIdentifier({ id: id, type: type, occurrenceKey: occurrenceKey, collection: collection }) {
        switch(type){
            case 'file':
                return {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: id,
                    mediaItemType: type,
                    occurrenceKey: occurrenceKey,
                    collectionName: collection
                };
            case 'link':
                return undefined;
            case 'external':
                return {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: id,
                    mediaItemType: 'file',
                    occurrenceKey: occurrenceKey,
                    collectionName: collection
                };
        }
    }
    constructor(...args){
        super(...args), this.state = {
            animate: false,
            offset: 0
        }, this.handleSize = ({ offset: offset })=>this.setState({
                offset: offset
            }), this.handleScroll = ({ animate: animate, offset: offset })=>this.setState({
                animate: animate,
                offset: offset
            }), this.onMediaClick = (cardClickHandler, child, surroundingItems)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (event, analyticsEvent)=>{
                const surroundings = {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    collectionName: child.props.collection,
                    list: surroundingItems
                };
                cardClickHandler(event, surroundings, analyticsEvent);
            };
    }
}

});
parcelRegister("1n5AE", function(module, exports) {

$parcel$export(module.exports, "defaultImageCardDimensions", () => $c1e5df8e84d43a31$export$d87a47989c00f322);
$parcel$export(module.exports, "getDefaultCardDimensions", () => $c1e5df8e84d43a31$export$ed7b8a4728e9c63);
const $c1e5df8e84d43a31$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $c1e5df8e84d43a31$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $c1e5df8e84d43a31$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $c1e5df8e84d43a31$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $c1e5df8e84d43a31$export$d87a47989c00f322;
    if (appearance === 'square') return $c1e5df8e84d43a31$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $c1e5df8e84d43a31$export$aeb48196afcd236a;
    return $c1e5df8e84d43a31$export$d87a47989c00f322;
};

});

parcelRegister("8TCRV", function(module, exports) {

$parcel$export(module.exports, "MediaFilmStripListItemSelector", () => $51e2bdb89be2a557$export$9f2ec2b609810bce);
$parcel$export(module.exports, "FilmstripView", () => $51e2bdb89be2a557$export$817db220b90d8024);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6whbE = parcelRequire("6whbE");

var $fpMeu = parcelRequire("fpMeu");
const $51e2bdb89be2a557$var$DURATION_MIN = 0.5;
const $51e2bdb89be2a557$var$DURATION_MAX = 1.0;
const $51e2bdb89be2a557$var$EXTRA_PADDING = 4;
const $51e2bdb89be2a557$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $51e2bdb89be2a557$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $51e2bdb89be2a557$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            animate: false,
            offset: 0
        };
    }
    constructor(props){
        super(props), this.previousOffset = 0, this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        }, this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        }, this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        }, this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        }, this.handleMutation = (mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        }, this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        }, this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        }, this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        }, this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        }, this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        }, this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($6whbE)))(this.handleMutation, 30, true));
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
	 * The furthest we can scroll, where the end of the buffer is just in view
	 */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $51e2bdb89be2a557$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $51e2bdb89be2a557$var$DURATION_MAX - $51e2bdb89be2a557$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $51e2bdb89be2a557$var$DURATION_MAX), $51e2bdb89be2a557$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $51e2bdb89be2a557$export$ba458cf715b18bd1);
        }
    }
    triggerScrollEvent() {
        if (!this.windowElement) return;
        const event = document.createEvent('MouseEvents');
        event.initEvent('scroll', true, true);
        this.windowElement.dispatchEvent(event);
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $51e2bdb89be2a557$var$EXTRA_PADDING) return newOffset - $51e2bdb89be2a557$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $51e2bdb89be2a557$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $51e2bdb89be2a557$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fpMeu.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fpMeu.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
        // trigger a "real" scroll event so lazily loaded cards realize they've been shown
        // note: we have to wait for the transition to end, otherwise the cards not visible when the scroll
        // event is triggered will be forever stuck in the loading screen (due to the lazy load)
        window.setTimeout(()=>this.triggerScrollEvent(), this.transitionDuration * 1000);
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fpMeu.FilmStripViewWrapper), {
            "data-testid": testId,
            children: [
                this.renderLeftArrow(),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fpMeu.FilmStripListWrapper), {
                    ref: this.handleWindowElementChange,
                    onWheel: this.handleScroll,
                    onTouchStart: this.handleTouchStart,
                    onTouchMove: this.handleTouchMove,
                    onTouchEnd: this.handleTouchEnd,
                    "data-testid": "filmstrip-list-wrapper",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fpMeu.FilmStripList), {
                        ref: this.handleBufferElementChange,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            transform: transform,
                            transitionProperty: transitionProperty,
                            transitionDuration: transitionDuration
                        },
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, $51e2bdb89be2a557$var$mapReactChildToReactNode)
                    })
                }),
                this.renderRightArrow()
            ]
        });
    }
}
function $51e2bdb89be2a557$var$mapReactChildToReactNode(child, index) {
    const key = $51e2bdb89be2a557$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fpMeu.FilmStripListItem), {
        index: key,
        children: child
    }, key);
}
function $51e2bdb89be2a557$var$isReactElement(child) {
    return !!child.type;
}

});
parcelRegister("6whbE", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $4bf31031c1570027$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$4bf31031c1570027$var$debounce.debounce = $4bf31031c1570027$var$debounce;
module.exports = $4bf31031c1570027$var$debounce;

});

parcelRegister("fpMeu", function(module, exports) {

$parcel$export(module.exports, "LeftArrow", () => $54f9ccb1c3ca850e$export$b39b1b86b48b621f);
$parcel$export(module.exports, "RightArrow", () => $54f9ccb1c3ca850e$export$6208675820d4cc50);
$parcel$export(module.exports, "FilmStripViewWrapper", () => $54f9ccb1c3ca850e$export$d37eb83491863cbb);
$parcel$export(module.exports, "FilmStripListWrapper", () => $54f9ccb1c3ca850e$export$4b7fe5339e3afada);
$parcel$export(module.exports, "FilmStripList", () => $54f9ccb1c3ca850e$export$710ee13c74b7a1f0);
$parcel$export(module.exports, "FilmStripListItem", () => $54f9ccb1c3ca850e$export$54cfc70c184c0713);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $k1DaH = parcelRequire("k1DaH");

var $1xzHS = parcelRequire("1xzHS");
const $54f9ccb1c3ca850e$export$924abd21043fc000 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.ArrowLeftWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.ArrowLeftWrapper), {
        ...props
    });
const $54f9ccb1c3ca850e$export$a5ffe38c17bbc0a1 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.ShadowRight), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.ShadowRight), {
        ...props
    });
const $54f9ccb1c3ca850e$export$abf07652016c7e56 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.ArrowRightWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.ArrowRightWrapper), {
        ...props
    });
const $54f9ccb1c3ca850e$export$b39b1b86b48b621f = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.LeftArrow), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.LeftArrow), {
        ...props
    });
const $54f9ccb1c3ca850e$export$6208675820d4cc50 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.RightArrow), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.RightArrow), {
        ...props
    });
const $54f9ccb1c3ca850e$export$d37eb83491863cbb = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.FilmStripViewWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.FilmStripViewWrapper), {
        ...props
    });
const $54f9ccb1c3ca850e$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.FilmStripListWrapper), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.FilmStripListWrapper), {
        ...props,
        ref: ref
    }));
const $54f9ccb1c3ca850e$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.FilmStripList), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.FilmStripList), {
        ...props,
        ref: ref
    }));
const $54f9ccb1c3ca850e$export$54cfc70c184c0713 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.FilmStripListItem), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.FilmStripListItem), {
        ...props
    });

});
parcelRegister("k1DaH", function(module, exports) {

$parcel$export(module.exports, "ArrowLeftWrapper", () => $bcdff6ce7bf895cc$export$924abd21043fc000);
$parcel$export(module.exports, "ShadowRight", () => $bcdff6ce7bf895cc$export$a5ffe38c17bbc0a1);
$parcel$export(module.exports, "ArrowRightWrapper", () => $bcdff6ce7bf895cc$export$abf07652016c7e56);
$parcel$export(module.exports, "LeftArrow", () => $bcdff6ce7bf895cc$export$b39b1b86b48b621f);
$parcel$export(module.exports, "RightArrow", () => $bcdff6ce7bf895cc$export$6208675820d4cc50);
$parcel$export(module.exports, "FilmStripViewWrapper", () => $bcdff6ce7bf895cc$export$d37eb83491863cbb);
$parcel$export(module.exports, "FilmStripListWrapper", () => $bcdff6ce7bf895cc$export$4b7fe5339e3afada);
$parcel$export(module.exports, "FilmStripList", () => $bcdff6ce7bf895cc$export$710ee13c74b7a1f0);
$parcel$export(module.exports, "FilmStripListItem", () => $bcdff6ce7bf895cc$export$54cfc70c184c0713);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $lqfmR = parcelRequire("lqfmR");

var $bcitO = parcelRequire("bcitO");

var $8TCRV = parcelRequire("8TCRV");


var $eGOwo = parcelRequire("eGOwo");
function $bcdff6ce7bf895cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bcdff6ce7bf895cc$var$filmStripViewStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'relative',
    padding: `${"var(--ds-space-025, 3px)"} 0`,
    borderRadius: '3px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover .arrow': {
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ellipsed-text': {
        whiteSpace: 'initial'
    }
});
const $bcdff6ce7bf895cc$var$filmStripListWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    width: 'inherit',
    overflow: 'hidden',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-025, 3px)"}`
});
const $bcdff6ce7bf895cc$var$filmStripListStyles = {
    name: "fsf3or",
    styles: "margin:0;padding:0;transition-property:transform;transition-timing-function:cubic-bezier(0.77, 0, 0.175, 1);white-space:nowrap;display:inline-block"
};
const $bcdff6ce7bf895cc$var$filmStripListPaddingOverride = {
    name: "qc3urb",
    styles: "padding:0 !important"
};
const $bcdff6ce7bf895cc$var$filmStripListItemStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    listStyleType: 'none',
    margin: 0,
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        paddingLeft: 0
    },
    display: 'inline-block',
    verticalAlign: 'middle',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0
});
const $bcdff6ce7bf895cc$var$arrowWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`,
    borderRadius: '100%',
    display: 'flex',
    cursor: 'pointer',
    transition: 'opacity 0.3s',
    boxShadow: "var(--ds-shadow-overlay, 0 1px 6px 0 rgba(0, 0, 0, 0.6))",
    color: "var(--ds-icon, black)",
    width: '30px',
    height: '30px',
    justifyContent: 'center',
    opacity: 0,
    '&:hover': {
        color: "var(--ds-text-subtle, black)",
        backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`
    },
    '&:active': {
        color: `var(--ds-text-selected, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`,
        backgroundColor: `var(--ds-background-selected, ${(0, $7bb4c1736002a04a$export$226de0355ed012f8)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    svg: {
        height: '30px',
        width: '20px'
    }
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bcdff6ce7bf895cc$var$arrowLeftWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)($bcdff6ce7bf895cc$var$arrowWrapperStyles, "left:var(--ds-space-100, 8px);svg{padding-right:var(--ds-space-025, 2px);}");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bcdff6ce7bf895cc$var$arrowRightWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)($bcdff6ce7bf895cc$var$arrowWrapperStyles, "right:var(--ds-space-100, 8px);svg{padding-left:var(--ds-space-025, 2px);}");
const $bcdff6ce7bf895cc$var$shadowStyles = {
    name: "atrqgo",
    styles: "position:absolute;z-index:10;height:100%;top:0;width:2px;background-color:var(--ds-border, rgba(0, 0, 0, 0.2))"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bcdff6ce7bf895cc$var$shadowLeftStyles = /*#__PURE__*/ (0, $1NIU8.css)($bcdff6ce7bf895cc$var$shadowStyles, "left:0;");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bcdff6ce7bf895cc$var$shadowRightStyles = /*#__PURE__*/ (0, $1NIU8.css)($bcdff6ce7bf895cc$var$shadowStyles, "right:0;");
const $bcdff6ce7bf895cc$var$ShadowLeft = ({ children: children })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$shadowLeftStyles
    }, children);
const $bcdff6ce7bf895cc$export$924abd21043fc000 = ({ children: children, onClick: onClick })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlaskit/ui-styling-standard/no-classname-prop,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$arrowLeftWrapperStyles,
        className: "arrow",
        onClick: onClick
    }, children);
const $bcdff6ce7bf895cc$export$a5ffe38c17bbc0a1 = ({ children: children })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$shadowRightStyles
    }, children);
const $bcdff6ce7bf895cc$export$abf07652016c7e56 = ({ children: children, onClick: onClick })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlaskit/ui-styling-standard/no-classname-prop,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$arrowRightWrapperStyles,
        className: "arrow",
        onClick: onClick
    }, children);
const $bcdff6ce7bf895cc$export$b39b1b86b48b621f = ({ onClick: onClick })=>/*#__PURE__*/ (0, $1NIU8.jsx)($bcdff6ce7bf895cc$var$ShadowLeft, null, /*#__PURE__*/ (0, $1NIU8.jsx)($bcdff6ce7bf895cc$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lqfmR))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $bcdff6ce7bf895cc$export$6208675820d4cc50 = ({ onClick: onClick })=>/*#__PURE__*/ (0, $1NIU8.jsx)($bcdff6ce7bf895cc$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, $1NIU8.jsx)($bcdff6ce7bf895cc$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bcitO))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $bcdff6ce7bf895cc$export$d37eb83491863cbb = ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$filmStripViewStyles,
        "data-testid": dataTestId
    }, children);
const $bcdff6ce7bf895cc$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$filmStripListWrapperStyles,
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId
    }, children));
const $bcdff6ce7bf895cc$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, $1NIU8.jsx)("ul", {
        css: [
            $bcdff6ce7bf895cc$var$filmStripListStyles,
            // Feature gate checks can't be inside the css() call. When cleaning up platform_editor_media_group_padding_css_fix merge the filmStripListPaddingOverride into filmStripListStyles.
            (0, $eGOwo.fg)('platform_editor_media_group_padding_css_fix') && $bcdff6ce7bf895cc$var$filmStripListPaddingOverride
        ],
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, children));
const $bcdff6ce7bf895cc$export$54cfc70c184c0713 = ({ children: children, index: index })=>/*#__PURE__*/ (0, $1NIU8.jsx)("li", {
        css: $bcdff6ce7bf895cc$var$filmStripListItemStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8TCRV.MediaFilmStripListItemSelector),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);

});
parcelRegister("bcitO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::101a51255f7076752a2af1f3fc652adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $826f266802ea1177$var$_react = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $826f266802ea1177$var$_arrowRight = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("ePxSL")));

var $826f266802ea1177$var$_arrowRight2 = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("WCqcH")));
function $826f266802ea1177$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $826f266802ea1177$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $826f266802ea1177$var$_react.default.createElement($826f266802ea1177$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $826f266802ea1177$var$_arrowRight2.default
    }, props));
$826f266802ea1177$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $826f266802ea1177$var$_default = module.exports.default = $826f266802ea1177$var$ArrowRightIcon;

});
parcelRegister("ePxSL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc01c6bd1fc51c7$var$_react = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $acc01c6bd1fc51c7$var$_baseNew = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $acc01c6bd1fc51c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc01c6bd1fc51c7$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $acc01c6bd1fc51c7$var$_react.default.createElement($acc01c6bd1fc51c7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$acc01c6bd1fc51c7$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $acc01c6bd1fc51c7$var$_default = module.exports.default = $acc01c6bd1fc51c7$var$ArrowRightIcon;

});

parcelRegister("WCqcH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b0338a1f0c13ece$var$_react = $0b0338a1f0c13ece$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $0b0338a1f0c13ece$var$_arrowRight = $0b0338a1f0c13ece$var$_interopRequireDefault((parcelRequire("ePxSL")));
function $0b0338a1f0c13ece$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0b0338a1f0c13ece$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $0b0338a1f0c13ece$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $0b0338a1f0c13ece$var$_arrowRight.default
    }));
$0b0338a1f0c13ece$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $0b0338a1f0c13ece$var$_default = module.exports.default = $0b0338a1f0c13ece$var$ArrowRightIcon;

});



parcelRegister("1xzHS", function(module, exports) {

$parcel$export(module.exports, "ArrowLeftWrapper", () => $28567b493ea4c8a6$export$924abd21043fc000);
$parcel$export(module.exports, "ShadowRight", () => $28567b493ea4c8a6$export$a5ffe38c17bbc0a1);
$parcel$export(module.exports, "ArrowRightWrapper", () => $28567b493ea4c8a6$export$abf07652016c7e56);
$parcel$export(module.exports, "LeftArrow", () => $28567b493ea4c8a6$export$b39b1b86b48b621f);
$parcel$export(module.exports, "RightArrow", () => $28567b493ea4c8a6$export$6208675820d4cc50);
$parcel$export(module.exports, "FilmStripViewWrapper", () => $28567b493ea4c8a6$export$d37eb83491863cbb);
$parcel$export(module.exports, "FilmStripListWrapper", () => $28567b493ea4c8a6$export$4b7fe5339e3afada);
$parcel$export(module.exports, "FilmStripList", () => $28567b493ea4c8a6$export$710ee13c74b7a1f0);
$parcel$export(module.exports, "FilmStripListItem", () => $28567b493ea4c8a6$export$54cfc70c184c0713);
/* wrappers-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lqfmR = parcelRequire("lqfmR");

var $bcitO = parcelRequire("bcitO");

var $8TCRV = parcelRequire("8TCRV");

var $eGOwo = parcelRequire("eGOwo");
const $28567b493ea4c8a6$var$filmStripViewStyles = null;
const $28567b493ea4c8a6$var$filmStripListWrapperStyles = null;
const $28567b493ea4c8a6$var$filmStripListStyles = null;
const $28567b493ea4c8a6$var$filmStripListPaddingOverride = null;
const $28567b493ea4c8a6$var$filmStripListItemStyles = null;
const $28567b493ea4c8a6$var$arrowWrapperStyles = null;
const $28567b493ea4c8a6$var$arrowLeftWrapperStyles = null;
const $28567b493ea4c8a6$var$arrowRightWrapperStyles = null;
const $28567b493ea4c8a6$var$shadowStyles = null;
const $28567b493ea4c8a6$var$shadowLeftStyles = null;
const $28567b493ea4c8a6$var$shadowRightStyles = null;
const $28567b493ea4c8a6$var$ShadowLeft = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhkbq8d",
            "_1ltvidpf"
        ]),
        children: children
    });
const $28567b493ea4c8a6$export$924abd21043fc000 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_2rko1osq _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhkexu1 _1e0c1txw _80omtlke _16qs1wkk _syazgpis _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3lyvy _irr3376n _9h8h1ldt _1di629zg",
            "_1ltvu2gc _uhasv77o",
            "arrow"
        ]),
        onClick: onClick,
        children: children
    });
const $28567b493ea4c8a6$export$a5ffe38c17bbc0a1 = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhkbq8d",
            "_1xi2idpf"
        ]),
        children: children
    });
const $28567b493ea4c8a6$export$abf07652016c7e56 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_2rko1osq _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhkexu1 _1e0c1txw _80omtlke _16qs1wkk _syazgpis _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3lyvy _irr3376n _9h8h1ldt _1di629zg",
            "_1xi2u2gc _7wy9v77o",
            "arrow"
        ]),
        onClick: onClick,
        children: children
    });
const $28567b493ea4c8a6$export$b39b1b86b48b621f = ({ onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)($28567b493ea4c8a6$var$ShadowLeft, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($28567b493ea4c8a6$export$924abd21043fc000, {
            onClick: onClick,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lqfmR))), {
                color: "currentColor",
                spacing: "spacious",
                label: "left"
            })
        })
    });
const $28567b493ea4c8a6$export$6208675820d4cc50 = ({ onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)($28567b493ea4c8a6$export$a5ffe38c17bbc0a1, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($28567b493ea4c8a6$export$abf07652016c7e56, {
            onClick: onClick,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bcitO))), {
                color: "currentColor",
                spacing: "spacious",
                label: "right"
            })
        })
    });
const $28567b493ea4c8a6$export$d37eb83491863cbb = ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": dataTestId,
        className: (0, $hcewu.default)([
            "_2rko1l7b _kqswh2mm _ca0q1ysw _u5f3idpf _n3td1ysw _19bvidpf _1yqxkb7n _1ajs4jg8"
        ]),
        children: children
    });
const $28567b493ea4c8a6$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bsb1kw7 _ca0qv77o _u5f31ysw _n3tdv77o _19bv1ysw"
        ]),
        children: children
    }));
const $28567b493ea4c8a6$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _k8m01e03 _6fl41kli _o5721q9c _1e0c1o8l",
            (0, $eGOwo.fg)('platform_editor_media_group_padding_css_fix') && "_ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3"
        ]),
        children: children
    }));
const $28567b493ea4c8a6$export$54cfc70c184c0713 = ({ children: children, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)("li", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1e0c1o8l _s7n4nkob _1wybidpf _1lhcidpf",
            (0, $8TCRV.MediaFilmStripListItemSelector)
        ]),
        "data-testid": "media-filmstrip-list-item",
        children: children
    }, index);

});




parcelRegister("dHHKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $307e48cc7be010e9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $jSAy9 = parcelRequire("jSAy9");

var $6Ramj = parcelRequire("6Ramj");

var $gAeD7 = parcelRequire("gAeD7");

var $aRuva = parcelRequire("aRuva");
var $93R6D = parcelRequire("93R6D");

var $1dILD = parcelRequire("1dILD");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $jMtSb = parcelRequire("jMtSb");

var $ftN6c = parcelRequire("ftN6c");

var $7DXmb = parcelRequire("7DXmb");

var $ex5uO = parcelRequire("ex5uO");

var $bMFKb = parcelRequire("bMFKb");
const $307e48cc7be010e9$var$RenderMediaInline = ({ rendererAppearance: rendererAppearance, clipboardAttrs: clipboardAttrs, collection: collectionName, eventHandlers: eventHandlers, identifier: identifier })=>{
    const [contextIdentifier, setContextIdentifier] = (0, $eJOHy.useState)();
    const [fileState, setFileState] = (0, $eJOHy.useState)();
    const mediaClient = (0, $eJOHy.useContext)((0, $93R6D.MediaClientContext));
    const contextIdentifierProvider = (0, $6Ramj.useProvider)('contextIdentifierProvider');
    (0, $eJOHy.useEffect)(()=>{
        if (contextIdentifierProvider) contextIdentifierProvider.then((resolvedContextID)=>{
            if (contextIdentifier !== resolvedContextID) setContextIdentifier(resolvedContextID);
        });
    }, [
        contextIdentifier,
        contextIdentifierProvider
    ]);
    const updateFileState = (0, $eJOHy.useCallback)(async (id)=>{
        const options = {
            collectionName: collectionName
        };
        try {
            if (mediaClient) {
                const fileState = await mediaClient.file.getCurrentState(id, options);
                setFileState(fileState);
            }
        } catch (error) {
        // do not set state on error
        }
    }, [
        collectionName,
        mediaClient
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const { id: id } = identifier;
        const nodeIsInCache = id && (0, $jMtSb.mediaIdentifierMap).has(id);
        if (!nodeIsInCache) (0, $jMtSb.mediaIdentifierMap).set(identifier.id, {
            ...identifier,
            collectionName: collectionName
        });
        return ()=>{
            (0, $jMtSb.mediaIdentifierMap).delete(id);
        };
    }, [
        identifier,
        collectionName
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const { id: id } = clipboardAttrs;
        id && updateFileState(id);
    }, [
        contextIdentifier,
        clipboardAttrs,
        updateFileState
    ]);
    /*
	 * Only show the loading view if the media client is not ready
	 * prevents calling the media API before the provider is ready
	 */ if (!mediaClient) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1dILD.MediaInlineCardLoadingView), {
        message: "",
        isSelected: false
    });
    const handleMediaInlineClick = (result)=>{
        if (eventHandlers?.media?.onClick) eventHandlers?.media?.onClick(result);
    };
    const shouldOpenMediaViewer = true;
    const shouldDisplayToolTip = true;
    const { id: id, collection: collection } = clipboardAttrs;
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...(0, $jMtSb.getClipboardAttrs)({
            id: id,
            collection: collection,
            contextIdentifierProvider: contextIdentifier,
            fileState: fileState
        }),
        "data-node-type": "mediaInline",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gAeD7.default), {
            identifier: identifier,
            onClick: handleMediaInlineClick,
            shouldOpenMediaViewer: shouldOpenMediaViewer,
            shouldDisplayToolTip: shouldDisplayToolTip,
            mediaClientConfig: mediaClient.mediaClientConfig,
            mediaViewerItems: Array.from((0, $jMtSb.mediaIdentifierMap).values())
        })
    }));
};
const $307e48cc7be010e9$var$MediaInline = (props)=>{
    const { collection: collection, id: id, intl: intl, rendererAppearance: rendererAppearance, featureFlags: featureFlags, type: fileType, alt: alt, width: width, height: height, marks: marks, ssr: ssr } = props;
    const clipboardAttrs = {
        id: id,
        collection: collection
    };
    const identifier = {
        id: id,
        mediaItemType: 'file',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        collectionName: collection
    };
    const mediaClient = (0, $eJOHy.useContext)((0, $93R6D.MediaClientContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (fileType === 'image') {
        const hasLinkMark = marks?.find((mark)=>mark.type.name === 'link');
        const borderMark = marks?.find((mark)=>mark?.type.name === 'border');
        const borderColor = borderMark?.attrs.color ?? '';
        const borderSize = borderMark?.attrs.size ?? 0;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7DXmb.ErrorBoundary), {
            component: (0, $ex5uO.ACTION_SUBJECT).RENDERER,
            componentId: (0, $bMFKb.ACTION_SUBJECT_ID).MEDIA_INLINE_IMAGE,
            createAnalyticsEvent: createAnalyticsEvent,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jSAy9.MediaInlineImageCard), {
                mediaClient: ssr?.config ? (0, $aRuva.getMediaClient)(ssr.config) : mediaClient,
                identifier: identifier,
                alt: alt,
                width: width,
                height: height,
                ssr: ssr,
                border: {
                    borderSize: borderSize,
                    borderColor: borderColor
                },
                serializeDataAttrs: true,
                shouldOpenMediaViewer: !hasLinkMark
            })
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)($307e48cc7be010e9$var$RenderMediaInline, {
        identifier: identifier,
        clipboardAttrs: clipboardAttrs,
        eventHandlers: props.eventHandlers,
        rendererAppearance: rendererAppearance,
        intl: intl,
        collection: collection,
        featureFlags: featureFlags
    });
};
var $307e48cc7be010e9$export$2e2bcd8739ae039 = (0, $6YFG2.default)($307e48cc7be010e9$var$MediaInline);

});
parcelRegister("jSAy9", function(module, exports) {

$parcel$export(module.exports, "MediaInlineImageCard", () => $1ce01a8e27c54526$export$fca833ae4278270f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $aQK2r = parcelRequire("aQK2r");

var $4nehu = parcelRequire("4nehu");
var $6YFG2 = parcelRequire("6YFG2");

var $ftN6c = parcelRequire("ftN6c");

var $fhbkk = parcelRequire("fhbkk");
var $1yWtS = parcelRequire("1yWtS");

var $iPHIU = parcelRequire("iPHIU");

var $93R6D = parcelRequire("93R6D");

var $52iZC = parcelRequire("52iZC");

var $92xoS = parcelRequire("92xoS");

var $2u6SE = parcelRequire("2u6SE");

var $hgI1e = parcelRequire("hgI1e");

var $7FDta = parcelRequire("7FDta");

var $cXjeN = parcelRequire("cXjeN");

var $71iJ2 = parcelRequire("71iJ2");

var $jOuuz = parcelRequire("jOuuz");
const $1ce01a8e27c54526$export$5d2cd1bea8591ba3 = ({ mediaClient: mediaClient, identifier: identifier, isSelected: isSelected, intl: intl, alt: alt, isLazy: isLazy, width: width, height: height, border: border, ssr: ssr, serializeDataAttrs: serializeDataAttrs, shouldOpenMediaViewer: shouldOpenMediaViewer, isViewOnly: isViewOnly })=>{
    const [fileState, setFileState] = (0, $eJOHy.useState)();
    const [subscribeError, setSubscribeError] = (0, $eJOHy.useState)();
    const [isFailedEventSent, setIsFailedEventSent] = (0, $eJOHy.useState)(false);
    const [isSucceededEventSent, setIsSucceededEventSent] = (0, $eJOHy.useState)(false);
    const [isMediaViewerVisible, setMediaViewerVisible] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = intl || (0, $4nehu.createIntl)({
        locale: 'en'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireFailedOperationalEvent = (error = new (0, $1yWtS.MediaCardError)('missing-error-data'), failReason)=>{
        if (!isFailedEventSent && fileState) {
            setIsFailedEventSent(true);
            (0, $fhbkk.fireFailedOperationalEvent)(fileState, error, failReason, createAnalyticsEvent);
        }
    };
    const fireSucceededOperationalEvent = ()=>{
        if (!isSucceededEventSent && fileState) {
            setIsSucceededEventSent(true);
            (0, $fhbkk.fireSucceededOperationalEvent)(fileState, createAnalyticsEvent);
        }
    };
    (0, $eJOHy.useEffect)(()=>{
        if (mediaClient) {
            const subscription = mediaClient.file.getFileState(identifier.id, {
                collectionName: identifier.collectionName
            }).subscribe({
                next: (fileState)=>{
                    setFileState(fileState);
                    setSubscribeError(undefined);
                },
                error: (e)=>{
                    setSubscribeError(e);
                }
            });
            return ()=>{
                subscription.unsubscribe();
            };
        }
    }, [
        identifier,
        mediaClient
    ]);
    const content = (dimensions)=>{
        if (!mediaClient) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jOuuz.InlineImageCardLoadingView), null);
        if (!ssr) {
            if (subscribeError) {
                const isUploading = fileState?.status === 'uploading';
                const errorMessage = isUploading ? (0, $2u6SE.messages).failedToUpload : (0, $2u6SE.messages).unableToLoadContent;
                const errorReason = fileState?.status === 'uploading' ? 'upload' : 'metadata-fetch';
                fireFailedOperationalEvent(new (0, $1yWtS.MediaCardError)(errorReason, subscribeError));
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $71iJ2.InlineImageCardErrorView), {
                    message: formatMessage(errorMessage)
                });
            }
            if (!fileState || fileState?.status === 'uploading') return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jOuuz.InlineImageCardLoadingView), null);
            if (fileState.status === 'error') {
                fireFailedOperationalEvent(new (0, $1yWtS.MediaCardError)('error-file-state', new Error(fileState.message)));
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $71iJ2.InlineImageCardErrorView), {
                    message: formatMessage((0, $2u6SE.messages).unableToLoadContent)
                });
            } else if (fileState.status === 'failed-processing') {
                fireFailedOperationalEvent(undefined, 'failed-processing');
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $71iJ2.InlineImageCardErrorView), {
                    message: formatMessage((0, $2u6SE.messages).unableToLoadContent)
                });
            } else if (!fileState.name) {
                fireFailedOperationalEvent(new (0, $1yWtS.MediaCardError)('metadata-fetch', new (0, $iPHIU.FileFetcherError)('emptyFileName', {
                    id: fileState.id
                })));
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $71iJ2.InlineImageCardErrorView), {
                    message: formatMessage((0, $2u6SE.messages).unableToLoadContent)
                });
            }
            if (fileState.status === 'processed') fireSucceededOperationalEvent();
        }
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $93R6D.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7FDta.InlineImageCard), {
            dimensions: dimensions,
            identifier: identifier,
            renderError: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $71iJ2.InlineImageCardErrorView), {
                    message: formatMessage((0, $2u6SE.messages).unableToLoadContent)
                }),
            alt: alt,
            ssr: ssr?.mode,
            isLazy: isLazy,
            crop: true,
            stretch: false
        }));
    };
    const aspectRatio = (0, $eJOHy.useMemo)(()=>width && height ? width / height : undefined, [
        width,
        height
    ]);
    /**
   * scaledDimensions is used to define the correct media size fetched from media service
   * inline images will only ever be rendered at a maximum height of H1 and so scaled dimensions
   * will only ever return a width and height where the height has a maximum height of H1
   */ const scaledDimension = (0, $eJOHy.useMemo)(()=>{
        if (!width || !height || !aspectRatio) return {
            width: width,
            height: height
        };
        return {
            width: Math.round(aspectRatio * (0, $hgI1e.referenceHeights)['h1']),
            height: (0, $hgI1e.referenceHeights)['h1']
        };
    }, [
        width,
        height,
        aspectRatio
    ]);
    const htmlAttributes = (0, $eJOHy.useMemo)(()=>{
        if (serializeDataAttrs) {
            const resolvedAttrs = fileState && fileState.status !== 'error' ? {
                'data-file-size': fileState.size,
                'data-file-mime-type': fileState.mimeType,
                'data-file-name': fileState.name
            } : {};
            return {
                'data-type': 'image',
                'data-node-type': 'mediaInline',
                'data-id': identifier.id,
                'data-collection': identifier.collectionName,
                'data-width': width,
                'data-height': height,
                'data-alt': alt,
                ...resolvedAttrs
            };
        }
        return {};
    }, [
        alt,
        fileState,
        height,
        identifier,
        width,
        serializeDataAttrs
    ]);
    const onMediaInlineImageClick = (0, $eJOHy.useCallback)((e)=>{
        if (shouldOpenMediaViewer) setMediaViewerVisible(true);
        // In edit mode (node content wrapper has contenteditable set to true), link redirection is disabled by default
        // We need to call "stopPropagation" here in order to prevent in editor view mode, the browser from navigating to
        // another URL if the media node is wrapped in a link mark.
        if (isViewOnly && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) e.preventDefault();
    }, [
        shouldOpenMediaViewer,
        isViewOnly
    ]);
    const onMediaInlinePreviewClose = (0, $eJOHy.useCallback)(()=>{
        setMediaViewerVisible(false);
    }, []);
    const mediaViewer = (0, $eJOHy.useMemo)(()=>{
        if (isMediaViewerVisible && mediaClient?.mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).createPortal(/*#__PURE__*/ (0, $1NIU8.jsx)((0, $52iZC.default), {
            collectionName: identifier.collectionName || '',
            items: [
                identifier
            ],
            mediaClientConfig: mediaClient?.mediaClientConfig,
            selectedItem: identifier,
            onClose: onMediaInlinePreviewClose
        }), document.body);
        return null;
    }, [
        identifier,
        isMediaViewerVisible,
        mediaClient?.mediaClientConfig,
        onMediaInlinePreviewClose
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $cXjeN.InlineImageWrapper), {
        isSelected: isSelected,
        aspectRatio: aspectRatio,
        borderColor: border?.borderColor,
        borderSize: border?.borderSize,
        htmlAttrs: htmlAttributes,
        onClick: onMediaInlineImageClick
    }, content(scaledDimension)), mediaViewer);
};
const $1ce01a8e27c54526$export$fca833ae4278270f = (0, $6YFG2.default)($1ce01a8e27c54526$export$5d2cd1bea8591ba3, {
    enforceContext: false
});

});
parcelRegister("fhbkk", function(module, exports) {

$parcel$export(module.exports, "getSucceededStatusPayload", () => $fc8abd8d5aaead0b$export$95e48cf5f4b392a4);
$parcel$export(module.exports, "getErrorStatusPayload", () => $fc8abd8d5aaead0b$export$b37f976ad373d2e0);
$parcel$export(module.exports, "getFailedProcessingStatusPayload", () => $fc8abd8d5aaead0b$export$d0b5daf3b6a26055);
$parcel$export(module.exports, "fireFailedOperationalEvent", () => $fc8abd8d5aaead0b$export$d66a74eca3334206);
$parcel$export(module.exports, "fireSucceededOperationalEvent", () => $fc8abd8d5aaead0b$export$3bc90882cb04fda4);

var $dUG6w = parcelRequire("dUG6w");

var $1yWtS = parcelRequire("1yWtS");
const $fc8abd8d5aaead0b$export$95e48cf5f4b392a4 = (fileState)=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'success',
            fileAttributes: {
                fileId: fileState?.id || '',
                fileSize: fileState?.size,
                fileMediatype: fileState?.mediaType,
                fileMimetype: fileState?.mimeType,
                fileStatus: fileState?.status
            }
        }
    };
};
const $fc8abd8d5aaead0b$export$b37f976ad373d2e0 = (fileId, error, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            ...(0, $dUG6w.extractErrorInfo)(error)
        }
    };
};
const $fc8abd8d5aaead0b$export$d0b5daf3b6a26055 = (fileId, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            failReason: 'failed-processing'
        }
    };
};
const $fc8abd8d5aaead0b$export$d66a74eca3334206 = (fileState, error = new (0, $1yWtS.MediaCardError)('missing-error-data'), failReason, createAnalyticsEvent)=>{
    const payload = failReason ? $fc8abd8d5aaead0b$export$d0b5daf3b6a26055(fileState?.id || 'unknown-id', fileState) : $fc8abd8d5aaead0b$export$b37f976ad373d2e0(fileState?.id || 'unknown-id', error, fileState);
    (0, $dUG6w.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
const $fc8abd8d5aaead0b$export$3bc90882cb04fda4 = (fileState, createAnalyticsEvent)=>{
    const payload = $fc8abd8d5aaead0b$export$95e48cf5f4b392a4(fileState);
    (0, $dUG6w.fireMediaCardEvent)(payload, createAnalyticsEvent);
};

});
parcelRegister("dUG6w", function(module, exports) {

$parcel$export(module.exports, "getRenderSucceededEventPayload", () => $7a3cd0208599350b$export$4006df18b24ad838);
$parcel$export(module.exports, "getDownloadSucceededEventPayload", () => $7a3cd0208599350b$export$30f484b360b0efe8);
$parcel$export(module.exports, "getRenderErrorRequestMetadata", () => $7a3cd0208599350b$export$1a2ec9b4a3a99d5e);
$parcel$export(module.exports, "extractErrorInfo", () => $7a3cd0208599350b$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "getRenderErrorEventPayload", () => $7a3cd0208599350b$export$ea8620de23983ca1);
$parcel$export(module.exports, "getDownloadFailedEventPayload", () => $7a3cd0208599350b$export$bd721ce2bd18db4c);
$parcel$export(module.exports, "getErrorEventPayload", () => $7a3cd0208599350b$export$d3944464e6ecd3d4);
$parcel$export(module.exports, "getRenderFailedFileStatusPayload", () => $7a3cd0208599350b$export$116834b91a04bd49);
$parcel$export(module.exports, "fireMediaCardEvent", () => $7a3cd0208599350b$export$60729f3fb03dcecc);
$parcel$export(module.exports, "createAndFireMediaCardEvent", () => $7a3cd0208599350b$export$4d33ada3618f7626);

var $4rKJa = parcelRequire("4rKJa");

var $1Z1Pq = parcelRequire("1Z1Pq");

var $5fWw9 = parcelRequire("5fWw9");
const $7a3cd0208599350b$export$31786e85bf49987b = (metadata, fileStatus)=>({
        fileMediatype: metadata.mediaType,
        fileMimetype: metadata.mimeType,
        fileId: metadata.id,
        fileSize: metadata.size,
        fileStatus: fileStatus
    });
const $7a3cd0208599350b$export$4006df18b24ad838 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'success',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $7a3cd0208599350b$export$30f484b360b0efe8 = (fileAttributes, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'success',
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $7a3cd0208599350b$export$81661af638dd90bc = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'cache-hit',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $7a3cd0208599350b$export$62c7b749808f1b8f = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'Remote-success',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $7a3cd0208599350b$export$c9d988402f74bba = (fileAttributes, performanceAttributes)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'external-uri'
        }
    });
const $7a3cd0208599350b$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $7a3cd0208599350b$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $7a3cd0208599350b$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError) && secondaryError.innerError?.message) return secondaryError.innerError?.message;
    if (secondaryError instanceof Error) return secondaryError.message;
    return error.message;
};
const $7a3cd0208599350b$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $7a3cd0208599350b$export$1a2ec9b4a3a99d5e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata;
};
const $7a3cd0208599350b$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $7a3cd0208599350b$export$4af9d71992e89714(error),
        error: $7a3cd0208599350b$export$88c61dcad53762da(error),
        errorDetail: $7a3cd0208599350b$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $7a3cd0208599350b$export$29aa614726672b2e(error)
    };
};
const $7a3cd0208599350b$export$ea8620de23983ca1 = (fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            ...$7a3cd0208599350b$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $7a3cd0208599350b$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext
        }
    });
const $7a3cd0208599350b$export$bd721ce2bd18db4c = (fileAttributes, error, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$7a3cd0208599350b$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $7a3cd0208599350b$export$1a2ec9b4a3a99d5e(error),
            traceContext: traceContext
        }
    });
const $7a3cd0208599350b$export$d3944464e6ecd3d4 = (cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'nonCriticalFail',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$7a3cd0208599350b$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $7a3cd0208599350b$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            cardStatus: cardStatus
        }
    });
const $7a3cd0208599350b$export$116834b91a04bd49 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'failed-processing',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
function $7a3cd0208599350b$export$60729f3fb03dcecc(payload, createAnalyticsEvent) {
    if (createAnalyticsEvent) {
        const event = createAnalyticsEvent((0, $1Z1Pq.sanitiseAnalyticsPayload)(payload));
        event.fire((0, $1f17110950ea8e13$export$ec1779cb96554e1));
    }
}
const $7a3cd0208599350b$export$4d33ada3618f7626 = (payload)=>{
    return (0, $5fWw9.default)((0, $1f17110950ea8e13$export$ec1779cb96554e1))((0, $1Z1Pq.sanitiseAnalyticsPayload)(payload));
};

});
const $1f17110950ea8e13$export$ec1779cb96554e1 = 'media';

parcelRegister("1Z1Pq", function(module, exports) {

$parcel$export(module.exports, "sanitiseAnalyticsPayload", () => $20926ab34ea0b90c$export$e24d38cbdf73bc1a);

var $eaj78 = parcelRequire("eaj78");

var $K2rwM = parcelRequire("K2rwM");
const $20926ab34ea0b90c$var$sanitiseFileId = (draft)=>{
    const { fileId: fileId } = draft.attributes.fileAttributes;
    draft.attributes.fileAttributes.fileId = fileId === 'external-image' || (0, (/*@__PURE__*/$parcel$interopDefault($eaj78)))(fileId) ? fileId : 'INVALID_FILE_ID';
};
const $20926ab34ea0b90c$var$hasFileAttributesWithFileId = (payload)=>'attributes' in payload && !!payload.attributes && typeof payload.attributes === 'object' && 'fileAttributes' in payload.attributes && !!payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes === 'object' && 'fileId' in payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes.fileId === 'string';
const $20926ab34ea0b90c$export$e24d38cbdf73bc1a = (payload)=>$20926ab34ea0b90c$var$hasFileAttributesWithFileId(payload) ? (0, $K2rwM.produce)(payload, $20926ab34ea0b90c$var$sanitiseFileId) : payload;

});


parcelRegister("1yWtS", function(module, exports) {

$parcel$export(module.exports, "MediaCardError", () => $f1bbe05207027c63$export$ec8d022824f41295);
$parcel$export(module.exports, "ImageLoadError", () => $f1bbe05207027c63$export$d0a45ab59b4606b);
$parcel$export(module.exports, "isUploadError", () => $f1bbe05207027c63$export$11f9f5835c5b9a04);
class $f1bbe05207027c63$export$ec8d022824f41295 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $f1bbe05207027c63$export$2c035820a31723e extends $f1bbe05207027c63$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $f1bbe05207027c63$export$10ab445310d30114 extends $f1bbe05207027c63$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $f1bbe05207027c63$export$18e89b7e50818288 extends $f1bbe05207027c63$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $f1bbe05207027c63$export$921ab4548acefaa4 = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $f1bbe05207027c63$export$d0a45ab59b4606b extends $f1bbe05207027c63$export$ec8d022824f41295 {
    constructor(source){
        super($f1bbe05207027c63$export$921ab4548acefaa4(source));
    }
}
function $f1bbe05207027c63$export$36b43e3dd9a92(err) {
    return err instanceof $f1bbe05207027c63$export$ec8d022824f41295;
}
const $f1bbe05207027c63$export$b380593ba3516c6f = (err)=>err instanceof $f1bbe05207027c63$export$2c035820a31723e;
const $f1bbe05207027c63$export$e1d87830b3784f94 = (err)=>err instanceof $f1bbe05207027c63$export$10ab445310d30114;
const $f1bbe05207027c63$export$443aeb298d35d79d = (err)=>$f1bbe05207027c63$export$36b43e3dd9a92(err) && err.primaryReason === 'local-preview-unsupported';
function $f1bbe05207027c63$export$f00bb5a138da22e1(err) {
    return err instanceof $f1bbe05207027c63$export$d0a45ab59b4606b;
}
const $f1bbe05207027c63$export$4536ca0b68b4caf9 = (primaryReason, error, updatePrimaryReason)=>{
    if ($f1bbe05207027c63$export$36b43e3dd9a92(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $f1bbe05207027c63$export$ec8d022824f41295(primaryReason, error.secondaryError);
        return error;
    }
    return new $f1bbe05207027c63$export$ec8d022824f41295(primaryReason, error);
};
const $f1bbe05207027c63$export$11f9f5835c5b9a04 = (error)=>error && error.primaryReason === 'upload';

});


parcelRegister("52iZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0820605509642c1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8uE0z = parcelRequire("8uE0z");

var $3ilWa = parcelRequire("3ilWa");

const $a0820605509642c1$var$MediaViewer = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("k9lR4")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
function $a0820605509642c1$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uE0z.default), {}),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3ilWa.MediaViewerPortal), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($a0820605509642c1$var$MediaViewer, {
                ...props
            })
        })
    });
}

});
parcelRegister("8uE0z", function(module, exports) {

$parcel$export(module.exports, "headerAndSidebarBackgroundColor", () => $acef3481867ac96c$export$442b7be89436c101);
$parcel$export(module.exports, "default", () => $acef3481867ac96c$export$2e2bcd8739ae039);
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cydC6 = parcelRequire("cydC6");

var $58yRG = parcelRequire("58yRG");
const $acef3481867ac96c$export$442b7be89436c101 = '#101214';
const $acef3481867ac96c$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $58yRG.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cydC6.default), {
        blankedColor: $acef3481867ac96c$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $acef3481867ac96c$export$2e2bcd8739ae039 = $acef3481867ac96c$var$ModalSpinner;

});
parcelRegister("cydC6", function(module, exports) {

$parcel$export(module.exports, "default", () => $de987251ba68b050$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hsRKd = parcelRequire("hsRKd");

var $6TR4y = parcelRequire("6TR4y");

var $eGOwo = parcelRequire("eGOwo");
const $de987251ba68b050$var$ModalSpinner = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6TR4y.default), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hsRKd.default), {
        ...props
    });
var $de987251ba68b050$export$2e2bcd8739ae039 = $de987251ba68b050$var$ModalSpinner;

});
parcelRegister("hsRKd", function(module, exports) {

$parcel$export(module.exports, "default", () => $602a58390d6d877a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $IW7jS = parcelRequire("IW7jS");

var $7ep4S = parcelRequire("7ep4S");

var $aWILV = parcelRequire("aWILV");
function $602a58390d6d877a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $602a58390d6d877a$var$overlayZindex = (0, $IW7jS.layers).modal() + 10;
const $602a58390d6d877a$export$5b927fc1ef8c468b = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1if7vbe1"
})({
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: $602a58390d6d877a$var$overlayZindex
});
$602a58390d6d877a$export$5b927fc1ef8c468b.displayName = 'Blanket';
const $602a58390d6d877a$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1if7vbe0"
})({
    name: "1aslf6p",
    styles: "position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
$602a58390d6d877a$export$52b4dfd89a6b3a1b.displayName = 'SpinnerWrapper';
const $602a58390d6d877a$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $602a58390d6d877a$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $gt9Am.jsx)($602a58390d6d877a$export$5b927fc1ef8c468b, {
        style: {
            backgroundColor: blankedColor || $602a58390d6d877a$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($602a58390d6d877a$export$52b4dfd89a6b3a1b, {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                size: "large",
                appearance: invertSpinnerColor || $602a58390d6d877a$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});

parcelRegister("6TR4y", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c5a6db7c09246b1$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");
const $7c5a6db7c09246b1$var$blanketStyles = null;
const $7c5a6db7c09246b1$var$spinnerStyles = null;
const $7c5a6db7c09246b1$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $7c5a6db7c09246b1$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            backgroundColor: blankedColor || $7c5a6db7c09246b1$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $hcewu.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                size: "large",
                appearance: invertSpinnerColor || $7c5a6db7c09246b1$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});



parcelRegister("3ilWa", function(module, exports) {

$parcel$export(module.exports, "MediaViewerPortal", () => $a84a2d0c9c47ded9$export$51aee4c01b17acde);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $67YQP = parcelRequire("67YQP");
const $a84a2d0c9c47ded9$export$51aee4c01b17acde = ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67YQP.default), {
        zIndex: 510,
        children: children
    });

});

parcelRegister("k9lR4", function(module, exports) {

let $eab599dda55180d7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $eab599dda55180d7$var$load("76n7a"),
    $eab599dda55180d7$var$load("l253H"),
    $eab599dda55180d7$var$load("7uCGO")
]).then(()=>parcelRequire('fnhCF'));

});


parcelRegister("2u6SE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a6a633f8f2ba076f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a6a633f8f2ba076f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    unableToLoadContent: {
        id: 'fabric.editor.unableToLoadContent',
        defaultMessage: "We couldn't load this content",
        description: 'Display this message when there is an error loading file content'
    },
    failedToUpload: {
        id: 'fabric.editor.failed_to_upload',
        defaultMessage: 'Failed to upload',
        description: 'Display this message when there is an error uploading a file'
    }
});

});

parcelRegister("7FDta", function(module, exports) {

$parcel$export(module.exports, "InlineImageCard", () => $2153b1d1e8a88e8e$export$bb1dd14451154199);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $3xaEP = parcelRequire("3xaEP");

var $iN7PZ = parcelRequire("iN7PZ");

var $eJ3rj = parcelRequire("eJ3rj");

var $jOuuz = parcelRequire("jOuuz");
const $2153b1d1e8a88e8e$export$bb1dd14451154199 = ({ dimensions: dimensions, identifier: identifier, renderError: renderError, alt: alt, isLazy: isLazy, ssr: ssr, crop: crop, stretch: stretch })=>{
    // Generate unique traceId for file
    const traceContext = (0, $eJOHy.useMemo)(()=>({
            traceId: (0, $3xaEP.getRandomHex)(8)
        }), []);
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO do we need to handle nonCriticalError
    const { preview: preview, error: previewError, onImageError: onImageError, onImageLoad: onImageLoad, getSsrScriptProps: getSsrScriptProps, copyNodeRef: copyNodeRef } = (0, $iN7PZ.useFilePreview)({
        identifier: identifier,
        ssr: ssr,
        dimensions: dimensions,
        traceContext: traceContext
    });
    if (previewError) return renderError({
        error: previewError
    });
    if (!preview) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jOuuz.InlineImageCardLoadingView), null);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJ3rj.MediaImage), {
        dataURI: preview.dataURI,
        alt: alt,
        previewOrientation: preview.orientation,
        onImageLoad: ()=>{
            onImageLoad(preview);
        },
        onImageError: onImageError,
        loading: isLazy ? 'lazy' : undefined,
        forceSyncDisplay: !!ssr,
        crop: crop,
        stretch: stretch,
        ref: copyNodeRef
    }), getSsrScriptProps && /*#__PURE__*/ (0, $1NIU8.jsx)("script", getSsrScriptProps()));
};

});
parcelRegister("iN7PZ", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $e54d3f9e11f733f6$export$4eaebdef02112fe4);

var $eJOHy = parcelRequire("eJOHy");

var $bbNl0 = parcelRequire("bbNl0");
var $4rKJa = parcelRequire("4rKJa");

var $kCvcX = parcelRequire("kCvcX");
var $djK7X = parcelRequire("djK7X");
var $3cc2J = parcelRequire("3cc2J");

var $fK3MF = parcelRequire("fK3MF");

var $e2t9t = parcelRequire("e2t9t");

var $33YQ1 = parcelRequire("33YQ1");

var $k9eRE = parcelRequire("k9eRE");
var $hNvWT = parcelRequire("hNvWT");
var $9Mg12 = parcelRequire("9Mg12");

var $i0gVY = parcelRequire("i0gVY");
var $8Dv9L = parcelRequire("8Dv9L");

var $3c1p9 = parcelRequire("3c1p9");
const $e54d3f9e11f733f6$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const [status, setStatus] = (0, $eJOHy.useState)('loading');
    const [error, setError] = (0, $eJOHy.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $eJOHy.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $eJOHy.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $eJOHy.useState)('not-resolved');
    const ssrReliabilityRef = (0, $eJOHy.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const requestDimensions = (0, $eJOHy.useMemo)(()=>dimensions ? (0, $3c1p9.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $3c1p9.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $9Mg12.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $8Dv9L.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $k9eRE.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $e2t9t.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $eJOHy.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $djK7X.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $bbNl0.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $eJOHy.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $33YQ1.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $33YQ1.MediaFilePreviewError)('metadata-fetch', (0, $4rKJa.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $3c1p9.useCurrentValueRef)(()=>{
        return (0, $k9eRE.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $eJOHy.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $3c1p9.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $3c1p9.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $eJOHy.useEffect)(()=>{
        const cachedPreview = (0, $9Mg12.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $3c1p9.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $hNvWT.isSupportedLocalPreview)(mediaType) && (0, $fK3MF.isMimeTypeSupportedByBrowser)(mimeType || '')) // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
        // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
        // Then, local Preview NOT available
        (0, $k9eRE.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
            setIsBannedLocalPreview(true);
            // CXP-2723 TODO: We might have to wrap this error in MediaCardError
            setNonCriticalError(e);
        });
        else if (!error && !nonCriticalError && (!preview || (0, $3c1p9.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $k9eRE.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
            const wrappedError = (0, $33YQ1.ensureMediaFilePreviewError)('preview-fetch', e);
            if (!preview) {
                setStatus('error');
                setError(wrappedError);
            } else // If there is already a preview, we consider it a non-critical error
            setNonCriticalError(wrappedError);
        });
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $eJOHy.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $k9eRE.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $k9eRE.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $k9eRE.isLocalPreview)(failedPreview);
        const isRemote = (0, $k9eRE.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $33YQ1.ImageLoadError)(failedPreview?.source);
            (0, $9Mg12.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $eJOHy.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $k9eRE.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $k9eRE.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $i0gVY.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $kCvcX.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("kCvcX", function(module, exports) {

$parcel$export(module.exports, "useCopyIntent", () => $556b9eb703c9e12d$export$46fd859414de9d62);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $3cc2J = parcelRequire("3cc2J");

var $bMoFA = parcelRequire("bMoFA");

var $b7hyt = parcelRequire("b7hyt");
function $556b9eb703c9e12d$var$useCurrentValueRef(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}
const $556b9eb703c9e12d$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const innerRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const registerCopyIntentRef = $556b9eb703c9e12d$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $bMoFA.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $bMoFA.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $eJOHy.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $eGOwo.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $eJOHy.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $eGOwo.fg)('platform_media_cross_client_copy')) (0, $b7hyt.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $b7hyt.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("3cc2J", function(module, exports) {

$parcel$export(module.exports, "useMediaClient", () => $d8e7b96ea4671e74$export$8b3e87ea56c3a345);

var $eJOHy = parcelRequire("eJOHy");

var $93R6D = parcelRequire("93R6D");

var $f7iZ0 = parcelRequire("f7iZ0");
const $d8e7b96ea4671e74$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $93R6D.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $f7iZ0.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};

});
parcelRegister("f7iZ0", function(module, exports) {

$parcel$export(module.exports, "MediaContext", () => $b977b15c2bc7301b$export$c94ff18a59d4c4d);
$parcel$export(module.exports, "MediaProvider", () => $b977b15c2bc7301b$export$57164260bc1f1218);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aRuva = parcelRequire("aRuva");

var $lMkQs = parcelRequire("lMkQs");
const $b977b15c2bc7301b$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $b977b15c2bc7301b$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $eJOHy.useMemo)(()=>(0, $aRuva.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $lMkQs.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($b977b15c2bc7301b$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};

});
parcelRegister("lMkQs", function(module, exports) {

$parcel$export(module.exports, "useMediaParsedSettings", () => $e0ef7db6f81da61d$export$d54af28440a5efc0);

var $eJOHy = parcelRequire("eJOHy");

var $4iDQM = parcelRequire("4iDQM");
const $e0ef7db6f81da61d$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $eJOHy.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $4iDQM.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};

});
parcelRegister("4iDQM", function(module, exports) {

$parcel$export(module.exports, "defaultMediaUserPreferences", () => $fd3af50559080092$export$2d23ed2854ac1650);
// Currently only supports boolean, string. Uncomment below to support number
const $fd3af50559080092$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $fd3af50559080092$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($fd3af50559080092$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $fd3af50559080092$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $fd3af50559080092$export$2d23ed2854ac1650 = $fd3af50559080092$export$7e209e67b965bc63($fd3af50559080092$var$defaultUserPreferences);

});




parcelRegister("bMoFA", function(module, exports) {

$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $93f079c5c30deecd$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $93f079c5c30deecd$export$aacb463551da2e8f);

var $h3W10 = parcelRequire("h3W10");
const $93f079c5c30deecd$var$getRequestErrorDetails = (err)=>{
    if ((0, $h3W10.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
};
const $93f079c5c30deecd$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $h3W10.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$93f079c5c30deecd$var$getRequestErrorDetails(error)
        }
    };
};
const $93f079c5c30deecd$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("b7hyt", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $b67882b47b14e094$export$f65ca476c09acec0);
const $b67882b47b14e094$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("djK7X", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $5a07b53d359ee7c3$export$90ff537b0999afb);

var $eJOHy = parcelRequire("eJOHy");

var $3cc2J = parcelRequire("3cc2J");

var $kNd6B = parcelRequire("kNd6B");
function $5a07b53d359ee7c3$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const fileState = (0, $kNd6B.useMediaStore)((state)=>state.files[id]);
    (0, $eJOHy.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("kNd6B", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $d5b1e147a2796345$export$8a9cc8c330400af8);

var $eOVQp = parcelRequire("eOVQp");

var $3cc2J = parcelRequire("3cc2J");
const $d5b1e147a2796345$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $eOVQp.useStore)(store, selector, equals);
function $d5b1e147a2796345$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $d5b1e147a2796345$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("eOVQp", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $aca29ade4cd157ce$export$6ccbb43953eebf8);

var $96y8R = parcelRequire("96y8R");

var $eJOHy = parcelRequire("eJOHy");

var $iHcr1 = parcelRequire("iHcr1");
var $aca29ade4cd157ce$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $aca29ade4cd157ce$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy)));
const { useSyncExternalStoreWithSelector: $aca29ade4cd157ce$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($iHcr1)));
let $aca29ade4cd157ce$var$didWarnAboutEqualityFn = false;
const $aca29ade4cd157ce$var$identity = (arg)=>arg;
function $aca29ade4cd157ce$export$6ccbb43953eebf8(api, selector = $aca29ade4cd157ce$var$identity, equalityFn) {
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$aca29ade4cd157ce$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $aca29ade4cd157ce$var$didWarnAboutEqualityFn = true;
    }
    const slice = $aca29ade4cd157ce$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $aca29ade4cd157ce$var$useDebugValue(slice);
    return slice;
}
const $aca29ade4cd157ce$var$createImpl = (createState)=>{
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $96y8R.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$aca29ade4cd157ce$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $aca29ade4cd157ce$export$185802fd694ee1f5 = (createState)=>createState ? $aca29ade4cd157ce$var$createImpl(createState) : $aca29ade4cd157ce$var$createImpl;
var $aca29ade4cd157ce$export$2e2bcd8739ae039 = (createState)=>{
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $aca29ade4cd157ce$export$185802fd694ee1f5(createState);
};

});



parcelRegister("e2t9t", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $3f058c26ca766723$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $3f058c26ca766723$export$768c370ed0dbaeb3);

var $4rKJa = parcelRequire("4rKJa");

var $33YQ1 = parcelRequire("33YQ1");
const $3f058c26ca766723$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $3f058c26ca766723$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $3f058c26ca766723$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $3f058c26ca766723$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $3f058c26ca766723$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $3f058c26ca766723$export$4af9d71992e89714(error),
        error: $3f058c26ca766723$export$88c61dcad53762da(error),
        errorDetail: $3f058c26ca766723$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $3f058c26ca766723$export$29aa614726672b2e(error)
    };
};
const $3f058c26ca766723$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$3f058c26ca766723$export$74aaf4784c2edb2c(new (0, $33YQ1.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("33YQ1", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $ba556c1ff2a47bc7$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $ba556c1ff2a47bc7$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $ba556c1ff2a47bc7$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $ba556c1ff2a47bc7$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $ba556c1ff2a47bc7$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $ba556c1ff2a47bc7$export$7156ce7b78b49bd7);
class $ba556c1ff2a47bc7$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $ba556c1ff2a47bc7$export$2c035820a31723e extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $ba556c1ff2a47bc7$export$10ab445310d30114 extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $ba556c1ff2a47bc7$export$18e89b7e50818288 extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $ba556c1ff2a47bc7$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $ba556c1ff2a47bc7$export$d0a45ab59b4606b extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(source){
        super($ba556c1ff2a47bc7$var$getImageLoadPrimaryReason(source));
    }
}
function $ba556c1ff2a47bc7$export$553696a6e769784c(err) {
    return err instanceof $ba556c1ff2a47bc7$export$96e559194c287cf4;
}
const $ba556c1ff2a47bc7$export$b380593ba3516c6f = (err)=>err instanceof $ba556c1ff2a47bc7$export$2c035820a31723e;
const $ba556c1ff2a47bc7$export$e1d87830b3784f94 = (err)=>err instanceof $ba556c1ff2a47bc7$export$10ab445310d30114;
const $ba556c1ff2a47bc7$export$443aeb298d35d79d = (err)=>$ba556c1ff2a47bc7$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $ba556c1ff2a47bc7$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($ba556c1ff2a47bc7$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $ba556c1ff2a47bc7$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $ba556c1ff2a47bc7$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("k9eRE", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $acdcd6198e7dee1d$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $acdcd6198e7dee1d$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $acdcd6198e7dee1d$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $acdcd6198e7dee1d$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $acdcd6198e7dee1d$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $acdcd6198e7dee1d$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $acdcd6198e7dee1d$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $acdcd6198e7dee1d$export$98e935d981c884d);

var $bajro = parcelRequire("bajro");

var $33YQ1 = parcelRequire("33YQ1");

var $9Mg12 = parcelRequire("9Mg12");

var $hNvWT = parcelRequire("hNvWT");
const $acdcd6198e7dee1d$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $bajro.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $9Mg12.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $acdcd6198e7dee1d$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $bajro.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $33YQ1.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $acdcd6198e7dee1d$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $acdcd6198e7dee1d$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $acdcd6198e7dee1d$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $hNvWT.getRemotePreview)(mediaClient, id, params, traceContext);
    return $acdcd6198e7dee1d$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $acdcd6198e7dee1d$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $hNvWT.getLocalPreview)(filePreview);
    return $acdcd6198e7dee1d$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("bajro", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $dd0a5c69b434a5a7$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $dd0a5c69b434a5a7$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $dd0a5c69b434a5a7$export$e51a8146182600b8);
const $dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $dd0a5c69b434a5a7$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $dd0a5c69b434a5a7$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $dd0a5c69b434a5a7$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $dd0a5c69b434a5a7$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'collection'),
        alt: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'alt'),
        height: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'height'),
        width: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'width'),
        size: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'size'),
        name: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'name'),
        mimeType: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'mimeType')
    };
};
const $dd0a5c69b434a5a7$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $dd0a5c69b434a5a7$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $dd0a5c69b434a5a7$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("9Mg12", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $d9909271b08294f2$export$b7e8ee3f7a41459);

var $4ZQua = parcelRequire("4ZQua");
const $d9909271b08294f2$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $d9909271b08294f2$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $d9909271b08294f2$export$b7e8ee3f7a41459 = new $d9909271b08294f2$export$7b50526c091bb915((0, $4ZQua.createObjectURLCache)());

});
parcelRegister("4ZQua", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $7640c7504dcb2ad6$export$ba71be67d5c32535);

var $adK77 = parcelRequire("adK77");

var $7xkt0 = parcelRequire("7xkt0");
const $7640c7504dcb2ad6$export$36d0f9859761643d = 50;
class $7640c7504dcb2ad6$var$ExtendedLRUCache extends (0, $7xkt0.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $adK77.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $7640c7504dcb2ad6$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $7640c7504dcb2ad6$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $7640c7504dcb2ad6$export$ba71be67d5c32535 = ()=>new $7640c7504dcb2ad6$export$75d1c8c9ba1d0773($7640c7504dcb2ad6$export$36d0f9859761643d);

});


parcelRegister("hNvWT", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $3247cef0fce3851d$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3247cef0fce3851d$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3247cef0fce3851d$export$bfe20bd01db02b3);

var $5JVfG = parcelRequire("5JVfG");

var $cK5G4 = parcelRequire("cK5G4");

var $33YQ1 = parcelRequire("33YQ1");

var $heXDA = parcelRequire("heXDA");
const $3247cef0fce3851d$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3247cef0fce3851d$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $cK5G4.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3247cef0fce3851d$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $heXDA.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3247cef0fce3851d$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $5JVfG.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3247cef0fce3851d$var$getImageLocalPreview(value);
            case 'video':
                return $3247cef0fce3851d$var$getVideoLocalPreview(value);
            default:
                throw new (0, $33YQ1.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $33YQ1.LocalPreviewError)('local-preview-unsupported');
};
const $3247cef0fce3851d$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $33YQ1.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("cK5G4", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $4622caaad73ce041$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $4622caaad73ce041$export$67689507e8404821);

var $9PgO0 = parcelRequire("9PgO0");

var $f8uqC = parcelRequire("f8uqC");

var $fOXQV = parcelRequire("fOXQV");

var $kHzU5 = parcelRequire("kHzU5");
const { Orientation: $4622caaad73ce041$var$Orientation, XResolution: $4622caaad73ce041$var$XResolution } = (0, $9PgO0.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $4622caaad73ce041$var$DPI_WEB_BASELINE = 72;
async function $4622caaad73ce041$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $4622caaad73ce041$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $4622caaad73ce041$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $4622caaad73ce041$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $4622caaad73ce041$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $4622caaad73ce041$var$DPI_WEB_BASELINE;
        else return $4622caaad73ce041$export$268f92356524130b(tags, $4622caaad73ce041$var$XResolution, $4622caaad73ce041$var$DPI_WEB_BASELINE) / $4622caaad73ce041$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $4622caaad73ce041$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$4622caaad73ce041$var$Orientation]) {
        const tagValue = tags[$4622caaad73ce041$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $9PgO0.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $4622caaad73ce041$export$67689507e8404821(file) {
    const tags = await (0, $f8uqC.readImageMetaTags)(file);
    return $4622caaad73ce041$var$getOrientationFromTags(tags);
}
function $4622caaad73ce041$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $4622caaad73ce041$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $4622caaad73ce041$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $f8uqC.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $4622caaad73ce041$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $4622caaad73ce041$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $fOXQV.loadImage)(src);
        const { width: width, height: height } = (0, $fOXQV.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("9PgO0", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $c8d64cb551bef33f$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $c8d64cb551bef33f$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $c8d64cb551bef33f$export$f6ea0c89fd7d156);
var $c8d64cb551bef33f$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $c8d64cb551bef33f$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $c8d64cb551bef33f$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("f8uqC", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $80e2aeeb99751964$export$41982b5c7acb23c4);

var $9PgO0 = parcelRequire("9PgO0");

var $dCEVY = parcelRequire("dCEVY");

var $7BlyC = parcelRequire("7BlyC");

var $3yAnp = parcelRequire("3yAnp");
async function $80e2aeeb99751964$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $9PgO0.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $7BlyC.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $3yAnp.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $9PgO0.ImageType).JPEG) return await (0, $dCEVY.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("dCEVY", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $ff103de7f6ab6f18$export$556b2ccec62d7f2a);

var $9PgO0 = parcelRequire("9PgO0");
const { XResolution: $ff103de7f6ab6f18$var$XResolution, YResolution: $ff103de7f6ab6f18$var$YResolution } = (0, $9PgO0.SupportedImageMetaTag);
let $ff103de7f6ab6f18$var$loadImage;

function $ff103de7f6ab6f18$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$ff103de7f6ab6f18$var$loadImage) {
            const module = await (parcelRequire("9JMwr"));
            $ff103de7f6ab6f18$var$loadImage = module.default || module;
        }
        $ff103de7f6ab6f18$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $ff103de7f6ab6f18$var$XResolution || key === $ff103de7f6ab6f18$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("9JMwr", function(module, exports) {

let $716df486413b4273$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $716df486413b4273$var$load("2HU4O").then(()=>parcelRequire('4Mu1O'));

});


parcelRegister("7BlyC", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $e9cd4ca7c89b16ee$export$5fb37736440fca6f);

var $fOXQV = parcelRequire("fOXQV");
let $e9cd4ca7c89b16ee$var$pngChunksExtract;

async function $e9cd4ca7c89b16ee$export$5fb37736440fca6f(file) {
    if (!$e9cd4ca7c89b16ee$var$pngChunksExtract) {
        const module = await (parcelRequire("dopkG"));
        $e9cd4ca7c89b16ee$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $fOXQV.fileToArrayBuffer)(file);
    const chunks = $e9cd4ca7c89b16ee$var$pngChunksExtract(buffer);
    return await $e9cd4ca7c89b16ee$export$9185743fdd58ce45(chunks);
}
async function $e9cd4ca7c89b16ee$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("fOXQV", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $cb7adf01e70d1e12$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $cb7adf01e70d1e12$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $cb7adf01e70d1e12$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $cb7adf01e70d1e12$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $cb7adf01e70d1e12$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $cb7adf01e70d1e12$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $cb7adf01e70d1e12$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $cb7adf01e70d1e12$export$61a1de0822e2820);

var $6OBnQ = parcelRequire("6OBnQ");

var $2Pj0H = parcelRequire("2Pj0H");

var $jb8ZN = parcelRequire("jb8ZN");

var $4w1Xx = parcelRequire("4w1Xx");

var $heBKY = parcelRequire("heBKY");

var $jP9Cl = parcelRequire("jP9Cl");

var $gAsmN = parcelRequire("gAsmN");

var $iqmbF = parcelRequire("iqmbF");

var $hLw8T = parcelRequire("hLw8T");

var $jpYYq = parcelRequire("jpYYq");

var $4SXVP = parcelRequire("4SXVP");

var $91IX3 = parcelRequire("91IX3");

var $i9oSq = parcelRequire("i9oSq");

var $1TONM = parcelRequire("1TONM");

var $3LgN4 = parcelRequire("3LgN4");

var $jmdLl = parcelRequire("jmdLl");
function $cb7adf01e70d1e12$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $cb7adf01e70d1e12$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $cb7adf01e70d1e12$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $cb7adf01e70d1e12$export$849633012686f7ee(file)
    };
}
async function $cb7adf01e70d1e12$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $cb7adf01e70d1e12$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $cb7adf01e70d1e12$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $cb7adf01e70d1e12$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $cb7adf01e70d1e12$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $cb7adf01e70d1e12$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $cb7adf01e70d1e12$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6OBnQ)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hLw8T)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SXVP)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hLw8T)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jpYYq)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iqmbF)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4w1Xx)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1TONM)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jb8ZN)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2Pj0H)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i9oSq)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($91IX3)))
    }
];
function $cb7adf01e70d1e12$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $cb7adf01e70d1e12$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $jmdLl.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3LgN4)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($heBKY)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jP9Cl)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gAsmN)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("6OBnQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $4f6469314c3d6ff1$var$_react = $4f6469314c3d6ff1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $4f6469314c3d6ff1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6469314c3d6ff1$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $4f6469314c3d6ff1$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$4f6469314c3d6ff1$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $4f6469314c3d6ff1$var$_default = module.exports.default = $4f6469314c3d6ff1$var$PdfDocument24Icon;

});

parcelRegister("2Pj0H", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $20ef173efcc507e4$var$_react = $20ef173efcc507e4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $20ef173efcc507e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $20ef173efcc507e4$var$Gif24Icon = (props)=>/*#__PURE__*/ $20ef173efcc507e4$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$20ef173efcc507e4$var$Gif24Icon.displayName = 'Gif24Icon';
var $20ef173efcc507e4$var$_default = module.exports.default = $20ef173efcc507e4$var$Gif24Icon;

});

parcelRegister("jb8ZN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $df6605c69004c362$var$_react = $df6605c69004c362$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $df6605c69004c362$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $df6605c69004c362$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $df6605c69004c362$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$df6605c69004c362$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $df6605c69004c362$var$_default = module.exports.default = $df6605c69004c362$var$PowerpointPresentation24Icon;

});

parcelRegister("4w1Xx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $349babaa4a8a09e8$var$_react = $349babaa4a8a09e8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $349babaa4a8a09e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $349babaa4a8a09e8$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $349babaa4a8a09e8$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$349babaa4a8a09e8$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $349babaa4a8a09e8$var$_default = module.exports.default = $349babaa4a8a09e8$var$WordDocument24Icon;

});

parcelRegister("heBKY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c8c1082e5cae77c8$var$_react = $c8c1082e5cae77c8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $c8c1082e5cae77c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c8c1082e5cae77c8$var$Sketch24Icon = (props)=>/*#__PURE__*/ $c8c1082e5cae77c8$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c8c1082e5cae77c8$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $c8c1082e5cae77c8$var$_default = module.exports.default = $c8c1082e5cae77c8$var$Sketch24Icon;

});

parcelRegister("jP9Cl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e6ea3d8b8f4b0c1d$var$_react = $e6ea3d8b8f4b0c1d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $e6ea3d8b8f4b0c1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e6ea3d8b8f4b0c1d$var$Figma24Icon = (props)=>/*#__PURE__*/ $e6ea3d8b8f4b0c1d$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e6ea3d8b8f4b0c1d$var$Figma24Icon.displayName = 'Figma24Icon';
var $e6ea3d8b8f4b0c1d$var$_default = module.exports.default = $e6ea3d8b8f4b0c1d$var$Figma24Icon;

});

parcelRegister("gAsmN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c1360329a45292df$var$_react = $c1360329a45292df$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $c1360329a45292df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c1360329a45292df$var$Executable24Icon = (props)=>/*#__PURE__*/ $c1360329a45292df$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c1360329a45292df$var$Executable24Icon.displayName = 'Executable24Icon';
var $c1360329a45292df$var$_default = module.exports.default = $c1360329a45292df$var$Executable24Icon;

});

parcelRegister("iqmbF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d69bdda0af90a430$var$_react = $d69bdda0af90a430$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $d69bdda0af90a430$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d69bdda0af90a430$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $d69bdda0af90a430$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d69bdda0af90a430$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $d69bdda0af90a430$var$_default = module.exports.default = $d69bdda0af90a430$var$GoogleDoc24Icon;

});

parcelRegister("hLw8T", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ceefc245c72865b3$var$_react = $ceefc245c72865b3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $ceefc245c72865b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ceefc245c72865b3$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $ceefc245c72865b3$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$ceefc245c72865b3$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $ceefc245c72865b3$var$_default = module.exports.default = $ceefc245c72865b3$var$GoogleForm24Icon;

});

parcelRegister("jpYYq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e22fa632d0a47674$var$_react = $e22fa632d0a47674$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $e22fa632d0a47674$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e22fa632d0a47674$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $e22fa632d0a47674$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e22fa632d0a47674$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $e22fa632d0a47674$var$_default = module.exports.default = $e22fa632d0a47674$var$GoogleSheet24Icon;

});

parcelRegister("4SXVP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $38eab1c43401fe51$var$_react = $38eab1c43401fe51$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $38eab1c43401fe51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $38eab1c43401fe51$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $38eab1c43401fe51$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$38eab1c43401fe51$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $38eab1c43401fe51$var$_default = module.exports.default = $38eab1c43401fe51$var$GoogleSlide24Icon;

});

parcelRegister("91IX3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $69271380a604c514$var$_react = $69271380a604c514$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $69271380a604c514$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $69271380a604c514$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $69271380a604c514$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$69271380a604c514$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $69271380a604c514$var$_default = module.exports.default = $69271380a604c514$var$ExcelSpreadsheet24Icon;

});

parcelRegister("i9oSq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d36c5d4aab250180$var$_react = $d36c5d4aab250180$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $d36c5d4aab250180$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36c5d4aab250180$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d36c5d4aab250180$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d36c5d4aab250180$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d36c5d4aab250180$var$_default = module.exports.default = $d36c5d4aab250180$var$Spreadsheet24Icon;

});

parcelRegister("1TONM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $162255ae7d5921b9$var$_react = $162255ae7d5921b9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $162255ae7d5921b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $162255ae7d5921b9$var$Presentation24Icon = (props)=>/*#__PURE__*/ $162255ae7d5921b9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$162255ae7d5921b9$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $162255ae7d5921b9$var$_default = module.exports.default = $162255ae7d5921b9$var$Presentation24Icon;

});

parcelRegister("3LgN4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2bd2c91c79a3039e$var$_react = $2bd2c91c79a3039e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $2bd2c91c79a3039e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2bd2c91c79a3039e$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $2bd2c91c79a3039e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2bd2c91c79a3039e$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $2bd2c91c79a3039e$var$_default = module.exports.default = $2bd2c91c79a3039e$var$SourceCode24Icon;

});

parcelRegister("jmdLl", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $d6ba8b104df87d35$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $d6ba8b104df87d35$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $d6ba8b104df87d35$export$ba4368c844580f9e);
function $d6ba8b104df87d35$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $d6ba8b104df87d35$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $d6ba8b104df87d35$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $d6ba8b104df87d35$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $d6ba8b104df87d35$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $d6ba8b104df87d35$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $d6ba8b104df87d35$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("dopkG", function(module, exports) {

let $9c012ac78e0c2259$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9c012ac78e0c2259$var$load("fWdHm").then(()=>parcelRequire('6TwJU'));

});


parcelRegister("3yAnp", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $a54c683875c3acaa$export$55c3bc9841b19de2);
function $a54c683875c3acaa$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("kHzU5", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $d080920ecf648ea4$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $d080920ecf648ea4$export$43142f95b8de7a91);
const $d080920ecf648ea4$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $d080920ecf648ea4$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $d080920ecf648ea4$export$43142f95b8de7a91 = (orientation)=>{
    return $d080920ecf648ea4$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("heXDA", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $e7f813388d1815ac$export$4269d30173168e5c);
const $e7f813388d1815ac$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("i0gVY", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $c6ffe105f3de4b84$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $c6ffe105f3de4b84$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $c6ffe105f3de4b84$export$de7c49925e44d75d);

var $itX9h = parcelRequire("itX9h");
const $c6ffe105f3de4b84$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $c6ffe105f3de4b84$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $c6ffe105f3de4b84$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $c6ffe105f3de4b84$var$dashed = (param)=>param ? `-${param}` : '';
const $c6ffe105f3de4b84$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$c6ffe105f3de4b84$var$dashed(collectionName)}${$c6ffe105f3de4b84$var$dashed(occurrenceKey)}`;
const $c6ffe105f3de4b84$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $c6ffe105f3de4b84$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $c6ffe105f3de4b84$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $itX9h.printFunctionCall)($c6ffe105f3de4b84$export$4310981e0aa4ce67, $c6ffe105f3de4b84$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $itX9h.printScript)([
        $c6ffe105f3de4b84$export$ede93d4564eaa8da.toString(),
        $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $c6ffe105f3de4b84$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $c6ffe105f3de4b84$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("itX9h", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $58d2f85efd2afaca$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $58d2f85efd2afaca$export$8b902fb69a2f17c1);

var $eGOwo = parcelRequire("eGOwo");
const $58d2f85efd2afaca$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $58d2f85efd2afaca$var$printParams = (args)=>args.map((arg)=>$58d2f85efd2afaca$var$printParam(arg)).join(',');
const $58d2f85efd2afaca$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$58d2f85efd2afaca$var$printParams(args)});`;
const $58d2f85efd2afaca$export$8b902fb69a2f17c1 = (statements)=>(0, $eGOwo.fg)('platform_remove_media_script_after_execution') ? `(function(){
 			 ${statements.join(';')}
  			document.currentScript.remove();
		})();
		` : `(function(){
   			${statements.join(';')}
 		})();`;

});


parcelRegister("8Dv9L", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $2f30a37781c6f0c3$export$d3a890b0f7844b6f);

var $i0gVY = parcelRequire("i0gVY");
const $2f30a37781c6f0c3$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $i0gVY.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $i0gVY.getKey)(identifier)];
};

});

parcelRegister("3c1p9", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $f93a7743871712e9$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $f93a7743871712e9$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $f93a7743871712e9$export$b3e10e1f0fbb71db);

var $eJOHy = parcelRequire("eJOHy");
const $f93a7743871712e9$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $f93a7743871712e9$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $f93a7743871712e9$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $f93a7743871712e9$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $f93a7743871712e9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}

});


parcelRegister("eJ3rj", function(module, exports) {

$parcel$export(module.exports, "MediaImage", () => $ae3b633856a58a58$export$1f97dc1e9d072692);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $jgJtD = parcelRequire("jgJtD");

var $2gvG4 = parcelRequire("2gvG4");

var $7meaC = parcelRequire("7meaC");

var $kHzU5 = parcelRequire("kHzU5");

var $82KGI = parcelRequire("82KGI");
const $ae3b633856a58a58$export$1f97dc1e9d072692 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ dataURI: dataURI, alt: alt = '', crop: crop = false, stretch: stretch = false, previewOrientation: previewOrientation = 1, crossOrigin: crossOrigin, onImageLoad: onImageLoad, onImageError: onImageError, loading: loading, forceSyncDisplay: forceSyncDisplay = false }, ref)=>{
    const [{ width: parentWidth, height: parentHeight }, setParentDimensions] = (0, $eJOHy.useState)({
        width: Infinity,
        height: Infinity
    });
    const [{ width: imgWidth, height: imgHeight }, setImageDimensions] = (0, $eJOHy.useState)({
        width: 0,
        height: 0
    });
    const [isImageLoaded, setIsImageLoaded] = (0, $eJOHy.useState)(false);
    const imgRef = (0, $eJOHy.useRef)(null);
    const imageRef = (0, $eJOHy.useCallback)((imgElem)=>{
        if (!imgElem || imgRef.current) return;
        if (imgElem.parentElement) {
            const { width: width, height: height } = imgElem.parentElement.getBoundingClientRect();
            setParentDimensions({
                width: width,
                height: height
            });
        }
        imgRef.current = imgElem;
    }, []);
    const mergedRef = (0, $82KGI.useMergeRefs)([
        imageRef,
        ref
    ]);
    const imageLoadHandler = (e)=>{
        if (!imgRef.current) return;
        setImageDimensions({
            width: imgRef.current.naturalWidth,
            height: imgRef.current.naturalHeight
        });
        setIsImageLoaded(true);
        onImageLoad?.(e.currentTarget);
    };
    const parentRatio = parentWidth / parentHeight;
    let imgRatio = imgWidth / imgHeight;
    let percentSize = '100%';
    /*
      Cover strategy means we want to full entire screen with an image. Here is an example:

         Image           Container   Result (░ - is what cropped out)
     ┌──────────────┐    ┌──────┐    ┌───┬──────┬───┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    └──────┘    └───┴──────┴───┘
     └──────────────┘
    */ const isCoverStrategy = crop;
    /*
      Fit strategy means image is fully inside container even if there is empty space left.
      Here is an example:

             Image            Container     Result
     ┌────────────────────┐    ┌──────┐    ┌──────┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     └────────────────────┘    └──────┘    └──────┘
     */ const isFitStrategy = !crop;
    const isImageRotated = previewOrientation !== 'from-image' && (0, $kHzU5.isRotated)(previewOrientation);
    /*
      When photo has orientation of 90deg or 270deg (stored in EXIF meta data)
      things get very tricky. Let me go through an two examples to explain how we deal with that:

      Example #1:

      Image comes in as    ________    But it needs to be     ┌──────┐
      horizontal picture  |        |   displayed as 750x1000  │      │
      of 1000x750         |        |   because orientation    │      │
                          |________|   say it must be rotated │      │
                                       90 degrees             │      │
                                                              └──────┘

      Container is smaller, and has dimensions of 100x200.
      So, input parameters are:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: true (means we want to cover)
        stretch: true
        previewOrientation: 6

      To see what true value of isImageMoreLandscapyThanContainer is we need to flip imgRatio.
      Since initial value is 1000/750 = 1.33 we can just do 1/1.3333 = 0.75.

      In this situation final values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: true
        isFitStrategy: false
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

      According to this variables state css will become:
        height: 100%;

      Now here is what going to happened.
      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply height: 100%.

      ┌────┬──────┬────┐  This will scale an image according to rules of proportions:
      │░░░░│▓▓▓▓▓▓│░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      │░░░░│▓▓▓▓▓▓│░░░░│  (orig img height) -> (scaled down img height)
      │░░░░│▓▓▓▓▓▓│░░░░│  750px             -> 200px  (is === container height, since `height: 100%`)
      └────┴──────┴────┘  (orig img width)  -> (scaled down img width)
              ↑           1000px            -> (200 x 1000) / 750 = 266.66px
       266x200 image in
       100x200 container.

      And only NOW browser will apply rotate: 90deg and turn image around.
      And we end up with this:

      ┌──────────┐   Where 200x266 image
      │░░░░░░░░░░│   in the 100x200 container.
      │░┌──────┐░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░└──────┘░│
      │░░░░░░░░░░│
      └──────────┘

      To combat this we will not make height: 100% but use ratio of an image.
      In this case imgRatio is now 0.75 (after flipping)

      New math will look like this:
      (orig img height) -> (scaled down img height)
      750px             -> (0.75 x 200px) = 150px (since `height: 75%`)
      (orig img width)  -> (scaled down img width)
      1000px            -> (150 x 1000) / 750 = 200px

      ┌─┬──────┬─┐  Now 150x200 image
      │░│▓▓▓▓▓▓│░│  is in 100x200 container.
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      └─┴──────┴─┘

      Unfortunately this is not over yet.



      Example #2:

      Input parameters:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: false (means we want to fit)  <-- This is only changed parameter
        stretch: true
        previewOrientation: 6

      Final variable values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: false
        isFitStrategy: true
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

       According to this variables state css will become:
        width: 100%;

      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply width: 100%.

      ┌────────┐  This will scale an image according to rules of proportions:
      │░░░░░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      ├────────┤  (orig img width)  -> (scaled down img width)
      │▓▓▓▓▓▓▓▓│  1000px            -> 100px (is === container width, since `width: 100%`)
      │▓▓▓▓▓▓▓▓│  (orig img height) -> (scaled down img height)
      ├────────┤  750px             -> (750x100) / 1000 = 75px
      │░░░░░░░░│
      └────────┘
          ↑
       100x75 image in
       100x200 container.

      Now browser will turn image 90degrees and we und up with:
      ┌──────────┐
      │          │  75x100 image in
      │ ┌──────┐ │  100x200 container
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ └──────┘ │
      │          │
      └──────────┘

      This looks familiar, and you might want to try what we did before and apply 75% not 100%.
      Unfortunately this will make it even worse. If you do calculation you will find out that
      final result will be 75x56 image in 100x200 container. For this and one more specific
      variables state we need to use original imgRatio for percent size. In this case it's 1.333, so
      134%

      New math will look like this:
      (orig img width)  -> (scaled down img width)
      1000px            -> (100px * 1.34) = 134px (since `width: 134%`)
      (orig img height) -> (scaled down img height)
      750px             -> (750x134) / 1000 = 100px

      So, 100x134 image in 100x200 container.
     */ if (isImageRotated) {
        imgRatio = 1 / imgRatio;
        percentSize = `${Math.ceil(imgRatio * 100)}%`;
    }
    /*
      Here is an example of when isImageMoreLandscapyThanContainer is true:

        Image      Container   OR   Image      Container
       ________      _____          ____           __
      |        | -> |     |        |    |   ->    |  |
      |________|    |_____|        |    |         |  |
                                   |    |         |  |
                                   |    |         |  |
                                   |____|         |__|

      For false just swap "Image" and "Container" in the example above.
     */ const isImageMoreLandscapyThanContainer = imgRatio > parentRatio;
    const isImgLandscape = imgWidth > imgHeight;
    /*
    This is two cases we need to cover as described in Example #2 above, but only for rotated landscape images.
     */ if (isImageRotated && isImgLandscape) {
        if (isFitStrategy || isImageMoreLandscapyThanContainer || isCoverStrategy && !isImageMoreLandscapyThanContainer) percentSize = `${Math.ceil(1 / imgRatio * 100)}%`;
    }
    /*
      When isStretchingAllowed is false image is as big as it is, but as small as container
      (according to strategy - cover or fit).
      isStretchingAllowed is true if image is bigger then container.
     */ const isStretchingAllowed = stretch;
    /*
      We do not want to show image until we finish deciding on sizing strategy.
      Though if it is a "fit" strategy (and image hasn't been rotated) we can display it right away,
      since it doesn't depend on isImageMoreLandscapyThanContainer nor it will change when isStretchingAllowed
      changes it's value after imgRatio and parentRatio get defined.
      The reason for exclude isImageRotated is that we need to calculate percentSize variable
      and we can do that only when image is loaded (and we have image size)
     */ const showImage = forceSyncDisplay || isImageLoaded || isFitStrategy && !isImageRotated;
    const style = {
        transform: 'translate(-50%, -50%)'
    };
    if (isStretchingAllowed) {
        if (isFitStrategy && isImageMoreLandscapyThanContainer) /*
          Image matches its width to container's and height scales accordingly.

            Image       Container       Result
                       ┌─────────┐    ┌─────────┐
           ┌──────┐    │         │    ├─────────┤
           │▓▓▓▓▓▓│ -> │         │ => │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           └──────┘    │         │    ├─────────┤
                       └─────────┘    └─────────┘
         */ style.width = percentSize;
        else if (isFitStrategy && !isImageMoreLandscapyThanContainer) /*
          Image matches its height to container's and width scales accordingly.
         */ style.height = percentSize;
        else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          In order to cover whole container guaranteed (even in expense of stretching)
          image matches its height to container's. Width scales accordingly and crops out sides.

             Image       Container    Result (░ - is what cropped out)
                       ┌─────────┐    ┌──┬──────┬──┐
           ┌──────┐    │         │    │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│ -> │         │ => │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│    │         │    │░░│▓▓▓▓▓▓│░░│
           └──────┘    │         │    │░░│▓▓▓▓▓▓│░░│
                       └─────────┘    └──┴──────┴──┘
         */ style.height = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.width = percentSize;
    } else {
        if (isFitStrategy) {
            /*
          We want image to be as wide and as height as container but not bigger then it's own size.

            Image       Container       Result
           ┌───────────┐    ┌─────────┐    ┌─────────┐
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    ├─────────┤
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓▓▓▓▓▓│->  │         │ => │▓▓▓▓▓▓▓▓▓│
           └───────────┘    │         │    │▓▓▓▓▓▓▓▓▓│
                            │         │    ├─────────┤
                            └─────────┘    └─────────┘

         And if image is smaller it doesn't change its size

            Image       Container       Result
                       ┌──────────┐    ┌──────────┐
                       │          │    │          │
           ┌──────┐    │          │    │ ┌──────┐ │
           │▓▓▓▓▓▓│ -> │          │ => │ │▓▓▓▓▓▓│ │
           │▓▓▓▓▓▓│    │          │    │ │▓▓▓▓▓▓│ │
           └──────┘    │          │    │ └──────┘ │
                       │          │    │          │
                       └──────────┘    └──────────┘
         */ style.maxWidth = percentSize;
            style.maxHeight = percentSize;
        } else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          We want to fill container but we can't stretch an image if it's smaller then container.

            Image            Container       Result
           ┌────────────┐    ┌───────┐    ┌──┬───────┬──┐
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│->  │       │ => │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    └───────┘    └──┴───────┴──┘
           └────────────┘

         */ style.maxHeight = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.maxWidth = percentSize;
    }
    if (!showImage || !dataURI) style.display = 'none';
    if (previewOrientation === 'from-image') style.imageOrientation = 'from-image';
    else if (previewOrientation > 1) {
        const transform = (0, $kHzU5.getCssFromImageOrientation)(previewOrientation);
        style.transform += ` ${transform}`;
    }
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            (0, $eGOwo.fg)('platform_media_add_ufo_custom_data') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2gvG4.default), {
                data: {
                    hasMediaComponent: true
                }
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7meaC.ImageComponent), {
                loading: loading,
                "data-testid": "media-image",
                "data-vc": "media-image",
                draggable: false,
                alt: alt,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                onLoad: imageLoadHandler,
                onError: onImageError,
                imageRef: mergedRef,
                src: dataURI,
                crossOrigin: crossOrigin,
                ...(0, $jgJtD.VcMediaWrapperProps)
            })
        ]
    });
});

});
parcelRegister("2gvG4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbfbe10f2ed80f4c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $bbfbe10f2ed80f4c$export$d12f56a472cdbe6c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $bbfbe10f2ed80f4c$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    (0, $eJOHy.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof globalThis?.structuredClone === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $bbfbe10f2ed80f4c$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof globalThis?.structuredClone === 'function') (0, $2QO3b.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $2QO3b.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("7meaC", function(module, exports) {

$parcel$export(module.exports, "ImageComponent", () => $decf1876772446e6$export$fd536c918b58ab76);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
/*
  TODO: https://product-fabric.atlassian.net/browse/CXP-3132

  We need to revisit omitting percentage values for Design Token since the parent applies transform(-50%, -50%) on it (packages/media/media-ui/src/mediaImage/index.tsx). This styling is complex and may potentially cause a bug if not treaded carefully.
*/ const $decf1876772446e6$var$imgStyle = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    objectFit: 'contain',
    imageOrientation: 'none'
};
const $decf1876772446e6$export$fd536c918b58ab76 = (props)=>{
    const { style: style, imageRef: imageRef, ...otherProps } = props;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, jsx-a11y/alt-text -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        ...otherProps,
        ref: imageRef,
        style: {
            ...$decf1876772446e6$var$imgStyle,
            ...style
        }
    }));
};

});


parcelRegister("jOuuz", function(module, exports) {

$parcel$export(module.exports, "InlineImageCardLoadingView", () => $e52ee95dd819f1f5$export$4b1a62d8f05056a7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7ep4S = parcelRequire("7ep4S");


var $gs8y9 = parcelRequire("gs8y9");
const $e52ee95dd819f1f5$export$4b1a62d8f05056a7 = ({ testId: testId = 'media-inline-image-card-loading-view', height: height = (0, $4cc10c9d7cf0f335$export$88e3664eef60c981) })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gs8y9.Frame), {
        testId: testId
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7ep4S.default), {
        size: height > (0, $4cc10c9d7cf0f335$export$88e3664eef60c981) ? 'medium' : 'small',
        interactionName: "media-inline-spinner"
    }));
};

});
/** Height threshold that determines icon size to be small or medium */ const $4cc10c9d7cf0f335$export$88e3664eef60c981 = 24;

parcelRegister("gs8y9", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $749039277bbba6eb$export$b89a827e9254211a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $h2bfU = parcelRequire("h2bfU");
const $749039277bbba6eb$export$b89a827e9254211a = ({ children: children, testId: testId })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: (0, $h2bfU.wrapperStyle),
        "data-testid": testId
    }, children);

});
parcelRegister("h2bfU", function(module, exports) {

$parcel$export(module.exports, "wrapperStyle", () => $fc77b29b684fca05$export$c4d4f06a25de97f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
const $fc77b29b684fca05$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'inline-flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    boxDecorationBreak: 'clone',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    color: `${"var(--ds-text, #172B4D)"}`,
    backgroundColor: `${"var(--ds-background-neutral, #091E420F)"}`,
    transition: '0.1s all ease-in-out',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `${"var(--ds-background-neutral-hovered, #091E4224)"}`
    }
});

});




parcelRegister("cXjeN", function(module, exports) {

$parcel$export(module.exports, "InlineImageWrapper", () => $d4bafcc76de9e7c0$export$8519fee8cc913056);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

var $9Ybet = parcelRequire("9Ybet");

var $dA9km = parcelRequire("dA9km");
function $d4bafcc76de9e7c0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// The MediaImage component needs to obtain its parent's dimensions.
// To achieve this, we have added an additional wrapper that allows
// for better interaction with the parent element. This is necessary
//  because the parent size changes its box-sizing with the node border.
const $d4bafcc76de9e7c0$var$sizeWrapperStyle = {
    name: "1ogmv4n",
    styles: "display:inline-flex;width:100%;height:100%"
};
const $d4bafcc76de9e7c0$export$8519fee8cc913056 = ({ children: children, isSelected: isSelected, aspectRatio: aspectRatio, borderSize: borderSize, borderColor: borderColor, htmlAttrs: htmlAttrs = {}, onClick: onClick })=>{
    const borderStyleVars = borderSize && borderColor ? {
        [(0, $dA9km.INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY)]: borderSize,
        [(0, $dA9km.INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY)]: (0, $9Ybet.hexToEditorBorderPaletteColor)(borderColor) || borderColor
    } : {};
    const aspectStyleVars = aspectRatio ? {
        [(0, $dA9km.INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY)]: aspectRatio
    } : {};
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...borderStyleVars,
            ...aspectStyleVars
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $dA9km.wrapperStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            borderSize && borderColor && (0, $dA9km.borderStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isSelected && (0, $dA9km.selectedStyle)
        ],
        "data-testid": "inline-image-wrapper",
        onClick: onClick,
        ...htmlAttrs
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $d4bafcc76de9e7c0$var$sizeWrapperStyle
    }, children)));
};

});

parcelRegister("71iJ2", function(module, exports) {

$parcel$export(module.exports, "InlineImageCardErrorView", () => $0e978e36eb47184d$export$cbdc50f98f4f8d00);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $3Isp2 = parcelRequire("3Isp2");

var $k71qx = parcelRequire("k71qx");


var $gs8y9 = parcelRequire("gs8y9");

var $8wscQ = parcelRequire("8wscQ");
const $0e978e36eb47184d$export$cbdc50f98f4f8d00 = ({ testId: testId = 'media-inline-image-card-error-view', message: message, icon: icon, height: height = (0, $4cc10c9d7cf0f335$export$88e3664eef60c981) })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gs8y9.Frame), {
        testId: testId
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        content: message,
        position: "top",
        tag: "span",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8wscQ.IconWrapper), null, icon || /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Isp2))), {
        label: "error",
        LEGACY_size: height > (0, $4cc10c9d7cf0f335$export$88e3664eef60c981) ? 'medium' : 'small',
        color: "var(--ds-icon-danger, #C9372C)"
    }))));
};

});
parcelRegister("8wscQ", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $dd51a983eed3d150$export$be58b4326e23250f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
function $dd51a983eed3d150$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dd51a983eed3d150$var$wrapperStyle = {
    name: "1xutr1y",
    styles: "display:flex;span > svg{vertical-align:top;}"
};
const $dd51a983eed3d150$export$be58b4326e23250f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $dd51a983eed3d150$var$wrapperStyle,
        "data-testid": "media-inline-image-card-icon"
    }, children);
};

});



parcelRegister("gAeD7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7756ce5e045a8803$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1dILD = parcelRequire("1dILD");

var $e2B2h = parcelRequire("e2B2h");



class $7756ce5e045a8803$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static{
        this.displayName = 'MediaInlineCardLoader';
    }
    async componentDidMount() {
        this.mounted = true;
        if (!this.state.MediaInlineCard) try {
            const [mediaClient, cardModule, mediaInlineErrorBoundaryModule] = await Promise.all([
                (parcelRequire("9aJ0Y")),
                (parcelRequire("lKx1C")),
                (parcelRequire("iK7g4"))
            ]);
            $7756ce5e045a8803$export$2e2bcd8739ae039.MediaInlineCard = mediaClient.withMediaClient(cardModule.MediaInlineCard);
            $7756ce5e045a8803$export$2e2bcd8739ae039.ErrorBoundary = mediaInlineErrorBoundaryModule.default;
            if (this.mounted) this.setState({
                MediaInlineCard: $7756ce5e045a8803$export$2e2bcd8739ae039.MediaInlineCard,
                ErrorBoundary: $7756ce5e045a8803$export$2e2bcd8739ae039.ErrorBoundary
            });
        } catch (error) {}
    }
    async componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { MediaInlineCard: MediaInlineCard, ErrorBoundary: ErrorBoundary } = this.state;
        const analyticsContext = {
            packageVersion: "platform-pkg",
            packageName: "0.0.0-use.local",
            componentName: 'mediaInlineCard',
            component: 'mediaInlineCard'
        };
        if (!MediaInlineCard || !ErrorBoundary) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1dILD.MediaInlineCardLoadingView), {
            message: ""
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
            data: analyticsContext,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(ErrorBoundary, {
                isSelected: this.props.isSelected,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(MediaInlineCard, {
                    ...this.props
                })
            })
        });
    }
    constructor(...args){
        super(...args), this.mounted = false, this.state = {
            MediaInlineCard: $7756ce5e045a8803$export$2e2bcd8739ae039.MediaInlineCard,
            ErrorBoundary: $7756ce5e045a8803$export$2e2bcd8739ae039.ErrorBoundary
        };
    }
}

});
parcelRegister("1dILD", function(module, exports) {

$parcel$export(module.exports, "MediaInlineCardLoadingView", () => $d9d101fa7192f9b2$export$4449fcbb2ad61ad1);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gPm7N = parcelRequire("gPm7N");

var $7ep4S = parcelRequire("7ep4S");

var $l31fP = parcelRequire("l31fP");

var $5ciG6 = parcelRequire("5ciG6");

var $j2rnC = parcelRequire("j2rnC");
class $d9d101fa7192f9b2$export$4449fcbb2ad61ad1 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { message: message, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, innerRef: innerRef, testId: testId = 'media-inline-card-loading-view' } = this.props;
        if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPm7N.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $j2rnC.IconTitleWrapper), {
                children: [
                    message,
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.RightIconPositionWrapper), {
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5ciG6.SpinnerWrapper), {
                            className: "inline-loading-spinner",
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                                size: 14
                            })
                        })
                    })
                ]
            })
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPm7N.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l31fP.IconAndTitleLayout), {
                title: message,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5ciG6.SpinnerWrapper), {
                    className: "inline-loading-spinner",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                        size: 14
                    })
                })
            })
        });
    }
}

});
parcelRegister("gPm7N", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $6c704da71263c31c$export$b89a827e9254211a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6Qiyl = parcelRequire("6Qiyl");
class $6c704da71263c31c$export$b89a827e9254211a extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { isSelected: isSelected, children: children, onClick: onClick, innerRef: innerRef, testId: testId, isError: isError } = this.props;
        const isInteractive = Boolean(onClick);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Qiyl.Wrapper), {
            ref: innerRef,
            isSelected: isSelected,
            isError: isError,
            tabIndex: isInteractive ? 0 : undefined,
            role: isInteractive ? 'button' : undefined,
            onClick: this.handleClick,
            onKeyPress: this.handleKeyPress,
            "data-testid": testId,
            children: children
        });
    }
    constructor(...args){
        super(...args), this.handleClick = (event)=>{
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        }, this.handleKeyPress = (event)=>{
            if (event.key !== ' ' && event.key !== 'Enter') return;
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
    }
}

});
parcelRegister("6Qiyl", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $4d86fdfdcd037721$export$e6dfd72ab29f8598);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $f2zWK = parcelRequire("f2zWK");

var $kH9TH = parcelRequire("kH9TH");

var $eGOwo = parcelRequire("eGOwo");
const $4d86fdfdcd037721$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kH9TH.Wrapper), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f2zWK.Wrapper), {
        ...props,
        ref: ref
    }));

});
parcelRegister("f2zWK", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $2d6ca48d8599c26d$export$e6dfd72ab29f8598);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $aWILV = parcelRequire("aWILV");
const $2d6ca48d8599c26d$var$selected = `
  cursor: pointer;
  box-shadow: 0 0 0 1px ${`var(--ds-border-selected, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`};
  outline: none;
  user-select: none;
  border-color: transparent;
  &, :hover, :focus, :active {
    text-decoration: none;
  }
`;
const $2d6ca48d8599c26d$var$isSelected = ({ isSelected: isSelected })=>{
    if (isSelected) return $2d6ca48d8599c26d$var$selected;
    else return 'user-select: text';
};
const $2d6ca48d8599c26d$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "e1t1vqsr0"
})({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
    boxDecorationBreak: 'clone',
    display: 'inline',
    borderRadius: "var(--ds-border-radius, 3px)",
    color: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$fbda843f0a27fe96)})`,
    backgroundColor: `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>$2d6ca48d8599c26d$var$isSelected(props), {
    transition: '0.1s all ease-in-out',
    MozUserSelect: 'none',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $7bb4c1736002a04a$export$46987b49aab6d1a8)})`
    }
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isError && {
        backgroundColor: `var(--ds-background-danger, ${0, $7bb4c1736002a04a$export$4b84fd0e2c617bd})`,
        cursor: 'default',
        '&:hover': {
            backgroundColor: `var(--ds-background-danger, ${0, $7bb4c1736002a04a$export$4b84fd0e2c617bd})`
        }
    });

});

parcelRegister("kH9TH", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $4a20dcc0fc7797ca$export$e6dfd72ab29f8598);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $4a20dcc0fc7797ca$var$selectedStyles = null;
const $4a20dcc0fc7797ca$var$notSelectedStyles = null;
const $4a20dcc0fc7797ca$var$errorStyles = null;
const $4a20dcc0fc7797ca$var$wrapperStyles = null;
const $4a20dcc0fc7797ca$export$e6dfd72ab29f8598 = ({ isSelected: isSelected, isError: isError, children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": "frame-wrapper",
        ...props,
        className: (0, $hcewu.default)([
            "_2rko1sit _v56415x0 _vwz47vkz _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _16d9qvcn _1e0c1nu9 _syazj3m3 _bfhk155y _1rkwglyw _80omtlke _irr3u9me",
            isSelected && "_12ji1r31 _1qu2glyw _12y31o36 _1h6d3acm _80omtlke _16qs1s9b _uiztglyw _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1",
            !isSelected && "_uizt1kdv",
            isError && "_bfhktaeo _80om73ad _irr3taeo"
        ]),
        children: children
    });

});



parcelRegister("l31fP", function(module, exports) {

$parcel$export(module.exports, "IconAndTitleLayout", () => $4a09982d44befcac$export$d34be4d513116847);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2HNHt = parcelRequire("2HNHt");

var $aAlzy = parcelRequire("aAlzy");

var $j2rnC = parcelRequire("j2rnC");

var $av9Of = parcelRequire("av9Of");
class $4a09982d44befcac$export$d34be4d513116847 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    renderAtlaskitIcon() {
        const { icon: icon, emoji: emoji } = this.props;
        if (emoji) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.EmojiWrapper), {
            children: emoji
        });
        if (!icon || typeof icon === 'string') return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.IconWrapper), {
            children: icon
        });
    }
    renderImageIcon(errored, testId) {
        const { icon: url } = this.props;
        if (!url || typeof url !== 'string') return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
            src: url,
            loaded: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aAlzy.Icon), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "smart-link-icon",
                src: url,
                "data-testid": `${testId}-image`
            }),
            errored: errored
        });
    }
    renderIconPlaceholder(testId) {
        const { defaultIcon: defaultIcon } = this.props;
        if (defaultIcon) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.IconWrapper), {
            children: defaultIcon
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.IconWrapper), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
                color: "currentColor",
                label: "link",
                LEGACY_size: "small",
                testId: `${testId}-default`
            })
        });
    }
    renderIcon(testId) {
        // We render two kinds of icons here:
        // - Image: acquired from either DAC or Teamwork Platform Apps;
        // - Atlaskit Icon: an Atlaskit SVG;
        // Each of these are scaled down to 12x12.
        const icon = this.renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = this.renderIconPlaceholder(testId);
        const image = this.renderImageIcon(placeholder, testId);
        return image || placeholder;
    }
    render() {
        const { children: children, title: title, titleColor: titleColor, testId: testId = 'media-inline-card-icon-and-title' } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $j2rnC.IconTitleWrapper), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: titleColor ? {
                    color: titleColor
                } : undefined,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.IconPositionWrapper), {
                        children: children || /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.IconEmptyWrapper), {}),
                                this.renderIcon(testId)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        "data-test-id": "title",
                        children: title
                    })
                ]
            })
        });
    }
}

});
parcelRegister("2HNHt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1f862656e4ed4164$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eJOHy = parcelRequire("eJOHy");
var $1f862656e4ed4164$var$React = $1f862656e4ed4164$var$_interopRequireWildcard($eJOHy);
function $1f862656e4ed4164$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $1f862656e4ed4164$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1f862656e4ed4164$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1f862656e4ed4164$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $1f862656e4ed4164$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $1f862656e4ed4164$var$loaded() {
    return {
        isLoaded: true
    };
}
function $1f862656e4ed4164$var$errored() {
    return {
        isErrored: true
    };
}
function $1f862656e4ed4164$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $1f862656e4ed4164$var$ImageRenderer = function(_React$Component) {
    $1f862656e4ed4164$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $1f862656e4ed4164$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $1f862656e4ed4164$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($1f862656e4ed4164$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($1f862656e4ed4164$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $1f862656e4ed4164$var$_possibleConstructorReturn(_this, _ret);
    }
    $1f862656e4ed4164$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($1f862656e4ed4164$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($1f862656e4ed4164$var$hasPropsChanged(this.props, nextProps)) this.setState($1f862656e4ed4164$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($1f862656e4ed4164$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($1f862656e4ed4164$var$React.Component);
module.exports.default = $1f862656e4ed4164$var$ImageRenderer;

});

parcelRegister("aAlzy", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $96d4786aad5cbd79$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $96d4786aad5cbd79$export$a201b065fc2e76a1);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $YR3FN = parcelRequire("YR3FN");

var $gbQOq = parcelRequire("gbQOq");

var $eGOwo = parcelRequire("eGOwo");
const $96d4786aad5cbd79$export$f04a61298a47a40f = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gbQOq.Icon), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $YR3FN.Icon), {
        ...props
    });
const $96d4786aad5cbd79$export$a201b065fc2e76a1 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gbQOq.AKIconWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $YR3FN.AKIconWrapper), {
        ...props
    });

});
parcelRegister("YR3FN", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $b89f5ef283d8dda8$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $b89f5ef283d8dda8$export$a201b065fc2e76a1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $aWILV = parcelRequire("aWILV");
function $b89f5ef283d8dda8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b89f5ef283d8dda8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $aWILV.default)("img", {
    target: "ebf58rv1"
})({
    name: "15ahtvm",
    styles: "height:14px;width:14px;margin-right:var(--ds-space-050, 4px);border-radius:2px;user-select:none;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
$b89f5ef283d8dda8$export$f04a61298a47a40f.defaultProps = {
    alt: 'icon'
};
const $b89f5ef283d8dda8$export$a201b065fc2e76a1 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ebf58rv0"
})({
    name: "18dmqdk",
    styles: "margin-right:var(--ds-space-negative-025, -2px)"
});

});

parcelRegister("gbQOq", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $c1a7d8f879d0ef13$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $c1a7d8f879d0ef13$export$a201b065fc2e76a1);
/* Icon-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Figure out a more scalable/responsive solution
// for vertical alignment.
// Current rationale: vertically positioned at the top of
// the smart card container (when set to 0). Offset this
// to position it with appropriate whitespace from the top.

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $c1a7d8f879d0ef13$var$iconStyles = null;
const $c1a7d8f879d0ef13$export$f04a61298a47a40f = ({ alt: alt, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        alt: alt || 'icon',
        ...props,
        className: (0, $hcewu.default)([
            "_2rkoyh40 _4t3idlk8 _1bsbdlk8 _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    });
// Used for 'untrue' icons which claim to be 16x16 but
// are less than that in height/width.
// TODO: Replace this override with proper AtlasKit solution.
const $c1a7d8f879d0ef13$var$akIconWrapperStyles = null;
const $c1a7d8f879d0ef13$export$a201b065fc2e76a1 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_2hwx1i6y"
        ]),
        children: children
    });

});


parcelRegister("j2rnC", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $886d47d94cf849e3$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $886d47d94cf849e3$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $886d47d94cf849e3$export$c73a53738ef9e3f);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $886d47d94cf849e3$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $886d47d94cf849e3$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $886d47d94cf849e3$export$ddce81e032b0736e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fgqnC = parcelRequire("fgqnC");

var $fJTWk = parcelRequire("fJTWk");

var $eGOwo = parcelRequire("eGOwo");
const $886d47d94cf849e3$export$be58b4326e23250f = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.IconWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.IconWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$e31a6cc0a4c97f0e = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.EmojiWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.EmojiWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$c73a53738ef9e3f = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.IconTitleWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.IconTitleWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$75180efdd3f4d9c2 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.LozengeWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.LozengeWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$a16269f205a2f280 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.LozengeBlockWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.LozengeBlockWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$91b164375b8037b5 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.RightIconPositionWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.RightIconPositionWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$7291f9f954790243 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.IconPositionWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.IconPositionWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$ddce81e032b0736e = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.IconEmptyWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.IconEmptyWrapper), {
        ...props
    });

});
parcelRegister("fgqnC", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $074dc70059ec90b0$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $074dc70059ec90b0$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $074dc70059ec90b0$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $074dc70059ec90b0$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "LozengeBlockWrapper", () => $074dc70059ec90b0$export$a16269f205a2f280);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $074dc70059ec90b0$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $074dc70059ec90b0$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $074dc70059ec90b0$export$ddce81e032b0736e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $aWILV = parcelRequire("aWILV");
function $074dc70059ec90b0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $074dc70059ec90b0$export$b993aa7bab57be12 = `
  & > span {
    height: 16px;
    width: 14px;
    position: absolute;
    top: 0;
    left: 0;
    line-height: 14px;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $074dc70059ec90b0$export$ded9fa9f58c8840e = `
  & > * > span {
    height: 16px;
    width: 14px;
    position: absolute;
    top: 0;
    left: 0;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $074dc70059ec90b0$export$be58b4326e23250f = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts57"
})("user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$074dc70059ec90b0$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$074dc70059ec90b0$export$b993aa7bab57be12);
const $074dc70059ec90b0$export$e31a6cc0a4c97f0e = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts56"
})("display:inline-block;margin-right:var(--ds-space-025, 2px);user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$074dc70059ec90b0$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$074dc70059ec90b0$export$b993aa7bab57be12);
const $074dc70059ec90b0$export$c73a53738ef9e3f = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts55"
})({
    name: "1h3cbh4",
    styles: "white-space:pre-wrap;word-break:break-all"
});
const $074dc70059ec90b0$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts54"
})({
    display: 'inline-block',
    verticalAlign: '1px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        marginLeft: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"} 0`
    }
});
const $074dc70059ec90b0$export$a16269f205a2f280 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts53"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        marginLeft: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"} 0`
    }
});
const $074dc70059ec90b0$export$91b164375b8037b5 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts52"
})({
    name: "1v89jht",
    styles: "margin-left:var(--ds-space-025, 2px);margin-right:var(--ds-space-050, 4px);position:relative;display:inline-block"
});
const $074dc70059ec90b0$export$7291f9f954790243 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts51"
})({
    name: "166gprz",
    styles: "margin-right:var(--ds-space-050, 4px);position:relative;display:inline-block"
});
const $074dc70059ec90b0$export$ddce81e032b0736e = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts50"
})({
    name: "vehdi",
    styles: "width:14px;height:100%;display:inline-block;opacity:0"
});

});

parcelRegister("fJTWk", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $fc17436d07b7b030$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $fc17436d07b7b030$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $fc17436d07b7b030$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $fc17436d07b7b030$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "LozengeBlockWrapper", () => $fc17436d07b7b030$export$a16269f205a2f280);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $fc17436d07b7b030$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $fc17436d07b7b030$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $fc17436d07b7b030$export$ddce81e032b0736e);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// TODO: remove this override behaviour for @atlaskit/icon-object

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $fc17436d07b7b030$var$iconObjectOverrideStyles = null;
// TODO: remove this override behaviour for @atlaskit/icon
const $fc17436d07b7b030$var$iconOverrideStyles = null;
const $fc17436d07b7b030$var$iconWrapperStyles = null;
const $fc17436d07b7b030$export$be58b4326e23250f = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$emojiWrapperStyles = null;
const $fc17436d07b7b030$export$e31a6cc0a4c97f0e = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _2hwxv77o _uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$iconTitleWrapperStyles = null;
const $fc17436d07b7b030$export$c73a53738ef9e3f = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_o5721jtm _1nmz9jpi"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$lozengeWrapperStyles = null;
const $fc17436d07b7b030$export$75180efdd3f4d9c2 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _s7n4t94y _1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$lozengeBlockWrapperStyles = null;
const $fc17436d07b7b030$export$a16269f205a2f280 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$rightIconPositionWrapperStyles = null;
const $fc17436d07b7b030$export$91b164375b8037b5 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_18u0v77o _2hwx1b66 _kqswh2mm _1e0c1o8l"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$iconPositionWrapperStyles = null;
const $fc17436d07b7b030$export$7291f9f954790243 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_2hwx1b66 _kqswh2mm _1e0c1o8l"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$iconEmptyWrapperStyles = null;
const $fc17436d07b7b030$export$ddce81e032b0736e = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_1bsbdlk8 _4t3i1osq _1e0c1o8l _tzy4idpf"
        ]),
        children: children
    });

});



parcelRegister("5ciG6", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $50909b30725a64a2$export$52b4dfd89a6b3a1b);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4pVLY = parcelRequire("4pVLY");

var $46TX0 = parcelRequire("46TX0");

var $eGOwo = parcelRequire("eGOwo");
const $50909b30725a64a2$export$52b4dfd89a6b3a1b = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46TX0.SpinnerWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4pVLY.SpinnerWrapper), {
        ...props
    });

});
parcelRegister("4pVLY", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $cbdd9d686d2b8174$export$52b4dfd89a6b3a1b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $fgqnC = parcelRequire("fgqnC");

var $aWILV = parcelRequire("aWILV");
function $cbdd9d686d2b8174$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cbdd9d686d2b8174$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $aWILV.default)((0, $fgqnC.IconTitleWrapper), {
    target: "e9a5khx0"
})({
    name: "1hde2gn",
    styles: "vertical-align:baseline;margin-left:var(--ds-space-025, 2px)"
});

});

parcelRegister("46TX0", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $f3d89c2e8c2ae7e2$export$52b4dfd89a6b3a1b);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $f3d89c2e8c2ae7e2$var$spinnerWrapperStyles = null;
const $f3d89c2e8c2ae7e2$export$52b4dfd89a6b3a1b = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_o5721jtm _1nmz9jpi _s7n418uv _18u0v77o"
        ]),
        children: children
    });

});



parcelRegister("9aJ0Y", function(module, exports) {

let $6ad7f73c1d418af0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6ad7f73c1d418af0$var$load("lrf77").then(()=>parcelRequire('bJDDe'));

});

parcelRegister("lKx1C", function(module, exports) {

let $fd5782f9c54fb147$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fd5782f9c54fb147$var$load("dxftE").then(()=>parcelRequire('1I6Li'));

});

parcelRegister("iK7g4", function(module, exports) {

let $da52273070a91008$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $da52273070a91008$var$load("8WIWL").then(()=>parcelRequire('04V4O'));

});



parcelRegister("5KYHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1056964a4a2008d5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $jYx9G = parcelRequire("jYx9G");
var $2bEPZ = parcelRequire("2bEPZ");

var $7yBx7 = parcelRequire("7yBx7");

var $fNh22 = parcelRequire("fNh22");

var $eGOwo = parcelRequire("eGOwo");


var $e2m7L = parcelRequire("e2m7L");

var $8dxEE = parcelRequire("8dxEE");
function $1056964a4a2008d5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1056964a4a2008d5$var$DEFAULT_WIDTH = 250;
const $1056964a4a2008d5$var$DEFAULT_HEIGHT = 200;
const $1056964a4a2008d5$var$uiMediaSingleBaseStyles = {
    name: "1a43hhz",
    styles: "transition:all 0.1s linear"
};
const $1056964a4a2008d5$var$uiMediaSingleLayoutStyles = {
    name: "1abqfmo",
    styles: "margin-left:50%;transform:translateX(-50%)"
};
const $1056964a4a2008d5$var$isMediaElement = (media)=>{
    if (!media) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { nodeType: nodeType, type: type } = media.props || {};
    // Use this to perform a rough check
    // better than assume the first item in children is media
    return nodeType === 'media' || [
        'external',
        'file',
        'link'
    ].indexOf(type) >= 0;
};
const $1056964a4a2008d5$var$checkForMediaElement = (children)=>{
    const [media] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (media && !$1056964a4a2008d5$var$isMediaElement(media) && media.props.children) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return $1056964a4a2008d5$var$checkForMediaElement(media.props.children);
    return media;
};
const $1056964a4a2008d5$export$507465eaf3c57f05 = (currentContainerWidth, layout)=>{
    if (!currentContainerWidth) // SSR mode fallback to default layout width
    switch(layout){
        case 'full-width':
            return 0, $7yBx7.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $7yBx7.akEditorWideLayoutWidth;
        default:
            return 0, $7yBx7.akEditorDefaultLayoutWidth;
    }
    return currentContainerWidth;
};
const $1056964a4a2008d5$var$MediaSingleWithChildren = (props)=>{
    const { rendererAppearance: rendererAppearance, featureFlags: featureFlags, isInsideOfBlockNode: isInsideOfBlockNode, layout: layout, width: widthAttr, widthType: widthType, allowCaptions: allowCaptions = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, media: media, caption: caption, editorAppearance: editorAppearance } = props;
    const [externalImageDimensions, setExternalImageDimensions] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState({
        width: 0,
        height: 0
    });
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const onExternalImageLoaded = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(({ width: width, height: height })=>{
        setExternalImageDimensions({
            width: width,
            height: height
        });
    }, []);
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { width: width = $1056964a4a2008d5$var$DEFAULT_WIDTH, height: height = $1056964a4a2008d5$var$DEFAULT_HEIGHT, type: type } = media.props;
    if (type === 'external') {
        const { width: stateWidth, height: stateHeight } = externalImageDimensions;
        if (width === null) width = stateWidth || $1056964a4a2008d5$var$DEFAULT_WIDTH;
        if (height === null) height = stateHeight || $1056964a4a2008d5$var$DEFAULT_HEIGHT;
    }
    if (width === null) {
        width = $1056964a4a2008d5$var$DEFAULT_WIDTH;
        height = $1056964a4a2008d5$var$DEFAULT_HEIGHT;
    }
    const isFullPage = rendererAppearance === 'full-page';
    const isFullWidth = rendererAppearance === 'full-width';
    const padding = isFullPage ? (0, $9a762f515f769003$export$12fd658e5eef0d79) * 2 : 0;
    const calcDimensions = (0, $eJOHy.useCallback)((mediaContainerWidth)=>{
        const containerWidth = $1056964a4a2008d5$export$507465eaf3c57f05(mediaContainerWidth, layout);
        const maxWidth = (0, $fNh22.isSSR)() && widthAttr && typeof widthAttr === 'number' && (0, $eGOwo.fg)('platform_editor_fix_image_size_diff_during_ssr') ? Math.max(widthAttr, containerWidth) : containerWidth;
        const maxHeight = height / width * maxWidth;
        const cardDimensions = {
            width: `${maxWidth}px`,
            height: `${maxHeight}px`
        };
        let nonFullWidthSize = containerWidth;
        if (!isInsideOfBlockNode && rendererAppearance !== 'comment') {
            const isContainerSizeGreaterThanMaxFullPageWidth = containerWidth - padding >= (0, $7yBx7.akEditorDefaultLayoutWidth);
            if (isContainerSizeGreaterThanMaxFullPageWidth) nonFullWidthSize = (0, $7yBx7.akEditorDefaultLayoutWidth);
            else nonFullWidthSize = containerWidth - padding;
        }
        const minWidth = Math.min((0, $7yBx7.akEditorFullWidthLayoutWidth), containerWidth - padding);
        const lineLength = isFullWidth ? minWidth : nonFullWidthSize;
        return {
            cardDimensions: cardDimensions,
            lineLength: lineLength
        };
    }, [
        height,
        isFullWidth,
        isInsideOfBlockNode,
        layout,
        padding,
        rendererAppearance,
        width,
        widthAttr
    ]);
    const originalDimensions = (0, $eJOHy.useMemo)(()=>({
            width: width,
            height: height
        }), [
        height,
        width
    ]);
    const { setHoverTarget: setHoverTarget } = (0, $e2m7L.useAnnotationRangeDispatch)();
    const { cancelTimeout: cancelTimeout, initiateTimeout: initiateTimeout, setIsWithinRange: setIsWithinRange } = (0, $8dxEE.useAnnotationHoverDispatch)();
    const isFullPageRenderer = isFullPage || isFullWidth;
    (0, $eJOHy.useEffect)(()=>{
        const mediaSingleElement = ref.current;
        const handleMouseEnter = (event)=>{
            cancelTimeout();
            if (event.buttons === 0) {
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                setHoverTarget && setHoverTarget(event.target);
                setIsWithinRange(true);
            }
        };
        const handleMouseLeave = ()=>{
            initiateTimeout();
        };
        if (mediaSingleElement && isFullPageRenderer) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            mediaSingleElement.addEventListener('mouseenter', handleMouseEnter);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            mediaSingleElement.addEventListener('mouseleave', handleMouseLeave);
        }
        return ()=>{
            if (mediaSingleElement && isFullPageRenderer) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                mediaSingleElement.removeEventListener('mouseenter', handleMouseEnter);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                mediaSingleElement.removeEventListener('mouseleave', handleMouseLeave);
            }
        };
    }, [
        setHoverTarget,
        isFullPageRenderer,
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    // Note: in SSR mode the `window` object is not defined,
    // therefore width here is 0, see:
    // packages/editor/editor-common/src/ui/WidthProvider/index.tsx
    const { width: renderWidth } = (0, $eJOHy.useContext)((0, $2bEPZ.WidthContext));
    const containerWidth = $1056964a4a2008d5$export$507465eaf3c57f05(renderWidth, layout);
    const { cardDimensions: cardDimensions, lineLength: lineLength } = (0, $eJOHy.useMemo)(()=>calcDimensions(containerWidth), [
        calcDimensions,
        containerWidth
    ]);
    const renderMediaSingle = ()=>{
        const mediaComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(media, {
            resizeMode: 'stretchy-fit',
            cardDimensions: cardDimensions,
            originalDimensions: originalDimensions,
            onExternalImageLoaded: onExternalImageLoaded,
            disableOverlay: true,
            featureFlags: featureFlags,
            mediaSingleElement: ref.current
        });
        const uiMediaSingleStyles = layout === 'full-width' || layout === 'wide' ? [
            $1056964a4a2008d5$var$uiMediaSingleBaseStyles,
            $1056964a4a2008d5$var$uiMediaSingleLayoutStyles
        ] : [
            $1056964a4a2008d5$var$uiMediaSingleBaseStyles
        ];
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jYx9G.default), {
            css: uiMediaSingleStyles,
            handleMediaSingleRef: ref,
            layout: layout,
            width: width,
            height: height,
            lineLength: isInsideOfBlockNode ? containerWidth : lineLength,
            containerWidth: containerWidth,
            size: {
                width: widthAttr,
                widthType: widthType
            },
            fullWidthMode: isFullWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            dataAttributes: dataAttributes,
            editorAppearance: editorAppearance
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, mediaComponent), allowCaptions && caption);
    };
    return renderMediaSingle();
};
const $1056964a4a2008d5$var$MediaSingle = (props)=>{
    const { children: children } = props;
    let media;
    const [node, caption] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children);
    if (!$1056964a4a2008d5$var$isMediaElement(node)) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const mediaElement = $1056964a4a2008d5$var$checkForMediaElement(node.props.children);
        if (!mediaElement) return node;
        media = mediaElement;
    } else media = node;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $1NIU8.jsx)($1056964a4a2008d5$var$MediaSingleWithChildren, {
        ...props,
        media: media,
        caption: caption
    });
};
var $1056964a4a2008d5$export$2e2bcd8739ae039 = (0, $6YFG2.default)($1056964a4a2008d5$var$MediaSingle);

});
parcelRegister("jYx9G", function(module, exports) {

$parcel$export(module.exports, "default", () => $209fa0d68bd3a102$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $k9JrM = parcelRequire("k9JrM");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $jgJtD = parcelRequire("jgJtD");

var $1I3aa = parcelRequire("1I3aa");

var $2zJxT = parcelRequire("2zJxT");

var $19zEl = parcelRequire("19zEl");

var $jhKIq = parcelRequire("jhKIq");
function $209fa0d68bd3a102$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $19zEl.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    if (mediaSingleWidth) {
        const pxWidth = (0, $2zJxT.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $7yBx7.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $7yBx7.DEFAULT_EMBED_CARD_WIDTH) - (0, $7yBx7.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $jhKIq.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            nodeType: nodeType
        }),
        ...(0, $eGOwo.fg)('platform_editor_fix_image_size_diff_during_ssr') ? {} : {
            'data-layout': layout
        },
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($k9JrM)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes,
        ...(0, $jgJtD.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jhKIq.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});
parcelRegister("k9JrM", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("2zJxT", function(module, exports) {

$parcel$export(module.exports, "getMediaSinglePixelWidth", () => $80b986ec0541becf$export$a6f4ec2edd25b07e);
$parcel$export(module.exports, "calcMediaSinglePixelWidth", () => $80b986ec0541becf$export$5091b2c0d1cd2361);
$parcel$export(module.exports, "calcMediaSingleMaxWidth", () => $80b986ec0541becf$export$a2e7f6320d796a21);
$parcel$export(module.exports, "getMediaSingleInitialWidth", () => $80b986ec0541becf$export$4ab195f543459515);
$parcel$export(module.exports, "calculateOffsetLeft", () => $80b986ec0541becf$export$ab1f1890e4428242);
$parcel$export(module.exports, "roundToNearest", () => $80b986ec0541becf$export$f72673597dacfcfa);
$parcel$export(module.exports, "calcMinWidth", () => $80b986ec0541becf$export$c7eaa4d46a45395);
$parcel$export(module.exports, "getMaxWidthForNestedNode", () => $80b986ec0541becf$export$4147ff5cc31ec064);
$parcel$export(module.exports, "getMaxWidthForNestedNodeNext", () => $80b986ec0541becf$export$bcefe8f1d5d7bbf3);
$parcel$export(module.exports, "currentMediaNodeWithPos", () => $80b986ec0541becf$export$22e4c8c04f58169d);

var $3lIcL = parcelRequire("3lIcL");

var $7yBx7 = parcelRequire("7yBx7");

var $19zEl = parcelRequire("19zEl");

var $1I3aa = parcelRequire("1I3aa");
function $80b986ec0541becf$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
const $80b986ec0541becf$export$5091b2c0d1cd2361 = ({ width: width, widthType: widthType = 'percentage', origWidth: origWidth, layout: layout, contentWidth: contentWidth, containerWidth: containerWidth, gutterOffset: gutterOffset = 0 })=>{
    if (widthType === 'pixel' && width) return width;
    switch(layout){
        case 'wide':
            return $80b986ec0541becf$var$calcLegacyWideWidth(containerWidth, origWidth, contentWidth);
        case 'full-width':
            // legacy and new experience have different definitions of full-width,
            // since it's for new experience, we convert to the new definition
            return $80b986ec0541becf$export$a2e7f6320d796a21(containerWidth);
        default:
            if (width) return Math.ceil(((contentWidth || containerWidth) + gutterOffset) * (width / 100) - gutterOffset);
    }
    // Handle the case of not resized node with wrapped layout
    // It's possible that the node is first inserted with align layout (e.g. jira)
    // in which the legacy image would render the width as min(origWidth, halfContentWidth).
    // However, new experience won't be able to distinguish the two. Thus, we render halfContentWidth
    // to make sure confluence legacy node is renderered correctly
    if ((0, $1I3aa.wrappedLayouts).includes(layout)) return Math.ceil((contentWidth || containerWidth) / 2);
    // set initial width for not resized legacy image
    return $80b986ec0541becf$export$4ab195f543459515(origWidth, // in case containerWidth is 0, we fallback to undefined to use akEditorDefaultLayoutWidth
    contentWidth || containerWidth || undefined);
};
/**
 * Calculate pixel width for legacy media single
 * @param contentWidth editor content width
 * @param containerWidth editor container width
 */ const $80b986ec0541becf$var$calcLegacyWideWidth = (containerWidth, origWidth, contentWidth)=>{
    if (contentWidth) {
        const wideWidth = Math.ceil(contentWidth * (0, $7yBx7.breakoutWideScaleRatio));
        return wideWidth > containerWidth ? contentWidth : wideWidth;
    }
    return origWidth;
};
const $80b986ec0541becf$export$a2e7f6320d796a21 = (containerWidth, editorAppearance)=>{
    const fullWidthPadding = editorAppearance === 'full-page' ? (0, $7yBx7.akEditorGutterPaddingDynamic)() * 2 : (0, $7yBx7.akEditorGutterPadding) * 2;
    return Math.min(containerWidth - fullWidthPadding, (0, $7yBx7.akEditorFullWidthLayoutWidth));
};
const $80b986ec0541becf$export$4ab195f543459515 = (origWidth = (0, $1I3aa.DEFAULT_IMAGE_WIDTH), maxWidth = (0, $7yBx7.akEditorDefaultLayoutWidth), minWidth = (0, $1I3aa.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH))=>{
    return Math.max(Math.min(origWidth, maxWidth), minWidth);
};
function $80b986ec0541becf$export$ab1f1890e4428242(insideInlineLike, insideLayout, pmViewDom, wrapper) {
    let offsetLeft = 0;
    if (wrapper && insideInlineLike && !insideLayout) {
        const currentNode = wrapper;
        const boundingRect = currentNode.getBoundingClientRect();
        offsetLeft = boundingRect.left - pmViewDom.getBoundingClientRect().left;
    }
    return offsetLeft;
}
const $80b986ec0541becf$export$f72673597dacfcfa = (value, interval = (0, $1I3aa.DEFAULT_ROUNDING_INTERVAL))=>Math.round(value / interval) * interval;
const $80b986ec0541becf$export$c7eaa4d46a45395 = (isVideoFile, contentWidth)=>{
    return Math.min(contentWidth, isVideoFile ? (0, $1I3aa.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $1I3aa.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
};
const $80b986ec0541becf$export$4147ff5cc31ec064 = (view, pos)=>{
    if (typeof pos !== 'number') return null;
    if ((0, $19zEl.isRichMediaInsideOfBlockNode)(view, pos)) {
        const $pos = view.state.doc.resolve(pos);
        const domNode = view.nodeDOM($pos.pos);
        if ($pos.nodeAfter && (0, $19zEl.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
        if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    }
    return null;
};
const $80b986ec0541becf$var$calcParentPadding = (view, resolvedPos)=>{
    // since table has constant padding, use hardcoded constant instead of query the dom
    const tablePadding = 8;
    const { tableCell: tableCell, tableHeader: tableHeader } = view.state.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].includes(resolvedPos.parent.type) ? tablePadding * 2 : 0;
};
const $80b986ec0541becf$export$bcefe8f1d5d7bbf3 = (view, pos, forInsertion)=>{
    if (typeof pos !== 'number') return null;
    const $pos = view.state.doc.resolve(pos);
    if ($pos && $pos.parent.type.name !== 'doc') return forInsertion ? $80b986ec0541becf$export$7cc71489edfd26f8($pos, view) : $80b986ec0541becf$export$4226a56ec6bfa71c($pos, view);
    return null;
};
const $80b986ec0541becf$export$4226a56ec6bfa71c = (resolvedPos, view)=>{
    const domNode = view.nodeDOM(resolvedPos.pos);
    if (resolvedPos.nodeAfter && (0, $19zEl.floatingLayouts).includes(resolvedPos.nodeAfter.attrs.layout) && domNode && domNode.parentElement) {
        const parentPadding = $80b986ec0541becf$var$calcParentPadding(view, resolvedPos);
        return domNode.parentElement.offsetWidth - parentPadding;
    }
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return null;
};
const $80b986ec0541becf$export$7cc71489edfd26f8 = (resolvedPos, view)=>{
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const parentDomNode = view.nodeDOM(parentPos);
    const parentPadding = $80b986ec0541becf$var$calcParentPadding(view, resolvedPos);
    if (parentDomNode instanceof HTMLElement) return parentDomNode.offsetWidth - parentPadding;
    return null;
};
const $80b986ec0541becf$export$22e4c8c04f58169d = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $3lIcL.NodeSelection)) || selection.node.type !== schema.nodes.mediaSingle) return;
    const pos = selection.$anchor.pos + 1;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.media) return;
    return {
        node: node,
        pos: pos
    };
};

});


const $9a762f515f769003$export$12fd658e5eef0d79 = 32;
const $9a762f515f769003$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';




$parcel$global.rlb("w71gM")
//# sourceMappingURL=media.976ba078.js.map
